import React, { Component } from 'react';
import moment from 'moment';
import html2canvas from 'html2canvas';
import jsPDF from 'jsPDF';
import WorkspaceTopBar from './Workspace/WorkspaceTopBar';
import WorkspaceCenter from './Workspace/WorkspaceCenter';
import WorkspaceLeftBar from './Workspace/WorkspaceLeftBar';
import WorkspaceBottomBar from './Workspace/WorkspaceBottomBar';
import WorkspaceNewVisualForm from './Workspace/WorkspaceNewVisualForm';
import WorkspaceModalError from './Workspace/WorkspaceModalError';
import WorkspaceService from '../services/WorkspaceService';
import ExportManager from '../managers/ExportManager';
import WorkspaceDataManager from '../managers/WorkspaceDataManager';

export const SystemWorkspaceIDs = {
	SalesByDay: -1,
	Sales: -2,
	Visits: -3,
	Autopays: -4
}

export default class WorkspacePage extends Component {
	constructor(props) {
		super(props);

		window.zzActiveObject = this;
		window.jackDebug = {}

		this.workspaceService = new WorkspaceService();
		this.exportManager = new ExportManager();
		let tmpOpenWorkspaces = localStorage.getItem('open-workspaces');
		if (tmpOpenWorkspaces === null) {
			tmpOpenWorkspaces = "[]";
			localStorage.setItem('open-workspaces', "[]")
		}
		tmpOpenWorkspaces = JSON.parse(tmpOpenWorkspaces);

		this.state = {
			leftBarOpen: false,
			fullscreenId: null,
			timeOpen: false,
			isDesignMode: false,
			isPublishing: false,
			allMaps: {
				brandMap: {},
				clientAccountMap: {},
				columnHeaderMap: {},
				consumerMap: {},
				dataSourceMap: {},
				districtStoreMap: {},
				districtLocationMap: {},
				districtMap: {},
				employeeMap: {},
				kpiNamingMap: {},
				locationMap: {},
				productCategoryMap: {},
				productMap: {},
				productSubCategoryMap: {},
				storeMap: {},
				treatmentCategoryMap: {},
				treatmentMap: {},
				treatmentSubCategoryMap: {},
				salesByDayMap: {},
				blastbidashMap: {}
			},
			defaultKpiOrder: {},
			calendarSpread: {
				weeks: [],
				months: [],
				quarters: [],
				years: [],
				all: []
			},
			allKpiOptions: {},
			metricDefinitions: [],
			cardType: null,
			workspaces: [],
			cardMetricLimits: {
				bar: 2,
				line: 1,
				pie: 1,
				stackedBar: 3,
				card: 1,
				table: 6,
				yoy: 5
			},
			defaultGroupings: {
				blast: "storeId",
				blastp: "employeeUniqueName",
				blastprod: "productId",
				blasttreat: "treatmentId",
				blastcust: "consumerId",
				blastsbd: "dateIndex",
				blastbidash: "storeId"
			},
			groupablesTree: {
				blast: [],
				blastp: [],
				blastcust: [],
				blastprod: [],
				blasttreat: [],
				blastsbd: [],
				blastbidash: []
			},
			openWorkspaces: tmpOpenWorkspaces,
			allData: {
				blast: [],
				blastp: [],
				blastcust: [],
				blastprod: [],
				blasttreat: [],
				blastsbd: [],
				blastbidash: []
			},
			longData: {
				blast: [],
				blastp: [],
				blastcust: [],
				blastprod: [],
				blasttreat: [],
				blastsbd: [],
				blastbidash: []
			},
			dataLastUpdate: null,
			timeFilter: {
				fromDate: parseInt(moment().format("YYYYMMDD")),
				toDate: parseInt(moment().format("YYYYMMDD"))
			},
			activeWorkspaceId: null,
			activeCard: null,
			activeFilter: null,
			expandedFilterMajors: [],


			defaultFilters: {
				all:{
					storeId:{
						label:"Location",
						map:"storeMap",
						options:[],
						selected:[]
					},
					onlineStoreId:{
						label:"Online Stores",
						map:"storeMap",
						options:[],
						selected:[]
					},
					employeeUniqueName:{
						label:"Employee",
						map:"employeeMap",
						options:[],
						selected:[]
					},
				}
			},
			workspaceFilters: {},
			filterPointer: {},

			modalType: "open-workspaces",
			modalOpen: false,
			newCardCoordinates: { x: 0, y: 0 },
			visualizationOpenMenuId: null,
			editCardIdentity: null,

			workspaceUsers: [],
			workspaceUserRoles: [{
				userTypeId: 0,
				userTypeName: 'System Admin',
				isShared: false,
				canEdit: false
			},
			{
				userTypeId: 1,
				userTypeName: 'Zor',
				isShared: false,
				canEdit: false
			},
			{
				userTypeId: 2,
				userTypeName: 'Zee',
				isShared: false,
				canEdit: false
			},
			{
				userTypeId: 3,
				userTypeName: 'Regional Manager',
				isShared: false,
				canEdit: false
			},
			{
				userTypeId: 4,
				userTypeName: 'Location Manager',
				isShared: false,
				canEdit: false
			},
			{
				userTypeId: 5,
				userTypeName: 'Stylist',
				isShared: false,
				canEdit: false
			}],
			workspaceDefault: false,
			shareWithEntity: "none",

			noClientAccountId: false,
			dataLoading: {
				blast: true,
				blastp: true,
				blastcust: true,
				blastprod: true,
				blasttreat: true,
				blastsbd: true,
				blastbidash: true
			},
			longDataLoading: true,
			cardLoading: null

		}

		this.longDates = [];

		this.activateKeyboardShortcuts = this.activateKeyboardShortcuts.bind(this);
		this.disableKeyboardShortcuts = this.disableKeyboardShortcuts.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);

		this.init = this.init.bind(this);
		this.fetchOnlineStores = this.fetchOnlineStores.bind(this);
		this.setupOnlineStores = this.setupOnlineStores.bind(this);
		this.setupFilters = this.setupFilters.bind(this);
		this.setupLongDates = this.setupLongDates.bind(this);

		this.pullDataByCards = this.pullDataByCards.bind(this);
		this.pullLongDataByCards = this.pullLongDataByCards.bind(this);
		this.setTimeRange = this.setTimeRange.bind(this);
		this.findSuitableFromDate = this.findSuitableFromDate.bind(this);

		this.setLeftBarOpen = this.setLeftBarOpen.bind(this);
		this.setTimeOpen = this.setTimeOpen.bind(this);
		this.setActiveFilter = this.setActiveFilter.bind(this);
		this.makeFilterSelection = this.makeFilterSelection.bind(this);
		this.selectAllFilters = this.selectAllFilters.bind(this);
		this.deSelectAllFilters = this.deSelectAllFilters.bind(this);
		this.makeFilterMajorSelection = this.makeFilterMajorSelection.bind(this);
		this.expandFilterMajor = this.expandFilterMajor.bind(this);
		this.resetFilters = this.resetFilters.bind(this);

		this.selectWorkspace = this.selectWorkspace.bind(this);
		this.goToDesignMode = this.goToDesignMode.bind(this);
		this.quitDesignMode = this.quitDesignMode.bind(this);

		this.selectMetric = this.selectMetric.bind(this);
		this.selectLocation = this.selectLocation.bind(this);
		this.selectDistrict = this.selectDistrict.bind(this);

		this.saveOpenWorkspacesLocal = this.saveOpenWorkspacesLocal.bind(this);
		this.saveWorkspace = this.saveWorkspace.bind(this);
		this.createWorkspace = this.createWorkspace.bind(this);
		this.duplicateWorkspace = this.duplicateWorkspace.bind(this);
		this.deleteWorkspace = this.deleteWorkspace.bind(this);
		this.publishWorkspace = this.publishWorkspace.bind(this);
		this.restoreWorkspace = this.restoreWorkspace.bind(this);
		this.closeWorkspace = this.closeWorkspace.bind(this);
		this.closeAllWorkspaces = this.closeAllWorkspaces.bind(this);
		this.toggleWorkspaceOpen = this.toggleWorkspaceOpen.bind(this);
		this.blankWorkspace = this.blankWorkspace.bind(this);
		this.modifyWorkspace = this.modifyWorkspace.bind(this);
		this.modifyWorkspaceNoSave = this.modifyWorkspaceNoSave.bind(this);
		this.clearAllVisuals = this.clearAllVisuals.bind(this);
		this.createVisual = this.createVisual.bind(this);
		this.saveEditVisual = this.saveEditVisual.bind(this);
		this.deleteVisual = this.deleteVisual.bind(this);

		this.openVisualizationMenu = this.openVisualizationMenu.bind(this)
		this.closeVisualizationMenu = this.closeVisualizationMenu.bind(this)

		this.selectCard = this.selectCard.bind(this);
		this.editCard = this.editCard.bind(this);

		this.openModal = this.openModal.bind(this);
		this.openNewCardModal = this.openNewCardModal.bind(this);
		this.openEditCardModal = this.openEditCardModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.metricDefinitions = this.metricDefinitions.bind(this);
		this.openFullscreen = this.openFullscreen.bind(this);
		this.closeFullscreen = this.closeFullscreen.bind(this);
		this.openVisualFilter = this.openVisualFilter.bind(this);
		this.closeVisualFilter = this.closeVisualFilter.bind(this);

		this.dateIndexToDate = this.dateIndexToDate.bind(this);
		this.dateToDateIndex = this.dateToDateIndex.bind(this);
		this.dateIndexRange = this.dateIndexRange.bind(this);
		this.commaFormat = this.commaFormat.bind(this);
		this.createRowId = this.createRowId.bind(this);
		this.toCammelCase = this.toCammelCase.bind(this);
		this.toFriendlyName = this.toFriendlyName.bind(this);
		this.generateFriendlyName = this.generateFriendlyName.bind(this);
		this.generateNameFromID = this.generateNameFromID.bind(this);

		this.exportPdf = this.exportPdf.bind(this);

		this.toggleShareOptions = this.toggleShareOptions.bind(this);
		this.selectRoleOption = this.selectRoleOption.bind(this);
		this.selectUserOption = this.selectUserOption.bind(this);
		this.selectRoleEditOption = this.selectRoleEditOption.bind(this);
		this.selectUserEditOption = this.selectUserEditOption.bind(this);
		this.generateShareRoleOptionsJsx = this.generateShareRoleOptionsJsx.bind(this);
		this.generateShareUserOptionsJsx = this.generateShareUserOptionsJsx.bind(this);
		this.generateDefaultCheckBoxAreaJsx = this.generateDefaultCheckBoxAreaJsx.bind(this);
		this.submitShareData = this.submitShareData.bind(this);
		this.toggleDefault = this.toggleDefault.bind(this);
		this.generateModalJsx = this.generateModalJsx.bind(this);
		this.toggleChart = this.toggleChart.bind(this);
		this.toggleLock = this.toggleLock.bind(this);
		this.openFavoriteWorkspaces = this.openFavoriteWorkspaces.bind(this);
		this.checkUsersList = this.checkUsersList.bind(this);

		window.dateIndexToDate = this.dateIndexToDate;
		window.dateToDateIndex = this.dateToDateIndex;
		window.dateIndexRange = this.dateIndexRange;
		window.commaFormat = this.commaFormat;
		window.toCammelCase = this.toCammelCase;
		window.toFriendlyName = this.toFriendlyName;
		window.generateFriendlyName = this.generateFriendlyName;
		window.generateNameFromID = this.generateNameFromID;
		window.test_moment = moment;

		this.activateKeyboardShortcuts();

		let self = this;
		self.props.superInit(self.init, undefined, () => { }, () => { });
	}

	componentWillUnmount() {
		this.disableKeyboardShortcuts();
	}

	activateKeyboardShortcuts() {
		document.addEventListener('keydown', this.handleKeyDown)
	}

	disableKeyboardShortcuts() {
		document.removeEventListener('keydown', this.handleKeyDown)
	}

	handleKeyDown(e) {
		let modalClose = this.state.modalOpen && this.state.modalType === 'new-card' || this.state.modalType === 'edit-card'
		let canPress = document.activeElement === document.body || document.activeElement.tabIndex === -1 || modalClose;
		canPress = canPress && ![112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123].includes(e.keyCode)
		// let tmpEls = document.getElementsByTagName('input');
		// for (var i = 0; i < tmpEls.length; i++) {
		// 	if (tmpEls[i].hasFocus()) {
		// 		canPress = false;
		// 	}
		// }

		if (canPress) {

			e = e || window.event;

			console.log("KEYCODE: " + e.keyCode)

			if (e.keyCode === 27) {
				e.preventDefault();
				if (modalClose) {
					this.closeModal(false);
				} else if (this.state.fullscreenId !== null) {
					this.setState({ fullscreenId: null });
				}
			}
			if (e.keyCode === 68) {
				if (this.state.activeWorkspaceId != null) {

					let canEdit = this.state.workspaces.reduce((e, r) => {
						if (r.id == this.state.activeWorkspaceId) {
							e = r.canEdit;
						}
						return e;
					}, false);

					if (canEdit === true && this.state.fullscreenId === null) {
						if (this.state.visualizationOpenMenuId !== null && !modalClose) {
							e.preventDefault();
							this.setState({ visualizationOpenMenuId: null })
						}
						if (this.state.isDesignMode) {
							if (!modalClose) {
								e.preventDefault();
								this.quitDesignMode();
							}
						} else {
							if(!this.props.isAaBiDashboardOnly) {
								this.goToDesignMode(this.state.activeWorkspaceId);
							}
						}
					}
				}
			}
		}
	}

	init() {
		if(zzDataCache.account.leaderboardOnly)
		{
			this.props.changePage('login', false);
			return;
		}
		
		let clientAccountId = '';

		if (zzDataCache.account.userType === 0) {

			//if (JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex !== undefined) {
			if ((localStorage.getItem('zzSettings') !== null) && JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex !== undefined) {
				clientAccountId = '/' + zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].clientAccountId;
			}
			else {
				clientAccountId = null;
			}
		} else {
			clientAccountId = '/' + JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].clientAccountId;
		}

		if (clientAccountId === null) {
			this.setState({
				noClientAccountId: true
			});
			return;
		}

		this.workspaceService.getEMaps(clientAccountId, res => {
			let allMaps = {
				...this.state.allMaps,
				employeeMap: Object.keys(res.map).reduce((r, e) => { r[e.toUpperCase()] = res.map[e]; return r; }, {})
			}
			let locationFilters = this.fetchOnlineStores();
			let finalLocFilters = [];
			res.defaultFilterValues.all.storeId.forEach(loc => {
				if(!locationFilters.includes(loc)) {
					finalLocFilters.push(loc);
				}
			})
			let defaultFilters = {
				...res.defaultFilterValues,
				all:{
					...res.defaultFilterValues.all,
					storeId:[...finalLocFilters],
					onlineStoreId: [...locationFilters],
				},
				blastp: {
					storeId:[...finalLocFilters],
					onlineStoreId: [...locationFilters],
					...res.defaultFilterValues.blastp
				}
			};
			defaultFilters = this.setupFilters(defaultFilters, allMaps);
			if(Object.keys(this.state.defaultFilters).length > 0) {
				defaultFilters = {
					...this.state.defaultFilters,
					...defaultFilters,
					blastp:{
						...defaultFilters.blastp
					}, 
					all: {
						...this.state.defaultFilters.all,
						...defaultFilters.all
					}
				}
			} 
			let wsFilter = JSON.parse(JSON.stringify(defaultFilters.all));
			this.setState({allMaps: allMaps, defaultFilters: defaultFilters, filterPointer:wsFilter, workspaceFilters: wsFilter});
		}, err => {
		})
		this.workspaceService.getCMaps(clientAccountId, res => {
			let allMaps = {
				...this.state.allMaps,
				consumerMap: res.map,
			}
			this.setState({allMaps:allMaps});
		}, err => {
		})
		this.workspaceService.getPTMaps(clientAccountId, res => {
			let allMaps = {
				...this.state.allMaps,
				productCategoryMap: res.productCategoryMap,
				productMap: res.productMap,
				productSubCategoryMap: res.productSubCategoryMap,
				treatmentCategoryMap: res.treatmentCategoryMap,
				treatmentMap: res.treatmentMap,
				treatmentSubCategoryMap: res.treatmentSubCategoryMap,
			}
			let locationFilters = this.fetchOnlineStores();
			let finalLocFilters = [];
			res.defaultFilterValues.all.storeId.forEach(loc => {
				if(!locationFilters.includes(loc)) {
					finalLocFilters.push(loc);
				}
			})
			let defaultFilters = {
				...res.defaultFilterValues,
				all:{
					...res.defaultFilterValues.all,
					storeId: [...finalLocFilters],
					onlineStoreId: [...locationFilters]
				},
				blastprod: {
					storeId: [...finalLocFilters],
					onlineStoreId: [...locationFilters],
					...res.defaultFilterValues.blastprod
				},
				blasttreat: {
					storeId: [...finalLocFilters],
					onlineStoreId: [...locationFilters],
					...res.defaultFilterValues.blasttreat
				}
			}
			defaultFilters = this.setupFilters(defaultFilters, allMaps);
			if(Object.keys(this.state.defaultFilters).length > 0) {
				defaultFilters = {
					...this.state.defaultFilters,
					...defaultFilters,
					all: {
						...this.state.defaultFilters.all,
						...defaultFilters.all
					},
					blastprod: {
						...defaultFilters.blastprod
					},
					blasttreat: {
						...defaultFilters.blasttreat
					}
				}
			}
			let wsFilter = JSON.parse(JSON.stringify(defaultFilters.all));
			this.setState({allMaps: allMaps, defaultFilters: defaultFilters, filterPointer:wsFilter, workspaceFilters: wsFilter});
		}, err => {
		})
		
		this.workspaceService.getMaps(clientAccountId, res => {
			let tmpLocSelections = [];
			let tmpLocOptions = [];
			// Setup districts TODO: The filter format here is invalid. Update to new Data Structure
			if (Object.keys(res.districtMap).length <= 1) {
				tmpLocOptions = Object.keys(res.locationMap);
				tmpLocSelections = Object.keys(res.locationMap);
			} else {
				tmpLocOptions = Object.keys(res.districtLocationMap).reduce((r, e) => {

					let tmpSelected = [];
					res.districtLocationMap[e].forEach(x => { tmpSelected.push(x); tmpLocSelections.push(x); });

					r.push({
						label: res.districtMap[e],
						value: e,
						options: res.districtLocationMap[e],
						selected: tmpSelected
					});

					return r;
				}, []);
			}

			// Set up friendly-name maps
			let allMaps = {
				...this.state.allMaps,
			//	brandMap: res.brandMap,
				clientAccountMap: res.clientAccountMap,
				columnHeaderMap: res.columnHeaderMap,
			//	consumerMap: res.consumerMap,
				dataSourceMap: res.dataSourceMap,
				districtStoreMap: res.districtStoreMap,
				districtLocationMap: res.districtLocationMap,
				districtMap: res.districtMap,
				//employeeMap: Object.keys(res.employeeMap).reduce((r, e) => { r[e.toUpperCase()] = res.employeeMap[e]; return r; }, {}),
				locationMap: res.locationMap,
				// productCategoryMap: res.productCategoryMap,
				// productMap: res.productMap,
				// productSubCategoryMap: res.productSubCategoryMap,
				storeMap: res.storeMap,
				// treatmentCategoryMap: res.treatmentCategoryMap,
				// treatmentMap: res.treatmentMap,
				// treatmentSubCategoryMap: res.treatmentSubCategoryMap,
			}

			let locationFilters = this.fetchOnlineStores();
			let finalLocFilters = [];
			res.defaultFilterValues.blast.storeId.forEach(loc => {
				if(!locationFilters.includes(loc)) {
					finalLocFilters.push(loc);
				}
			})

			// Filter setup
			let defaultFilters= {
				...res.defaultFilterValues,
				all:{
					...res.defaultFilterValues.all,
					storeId: [...finalLocFilters]
				},
				blast: {
					storeId: [...finalLocFilters]
				}
			} ;
			defaultFilters = this.setupFilters(defaultFilters, allMaps);
			if(Object.keys(this.state.defaultFilters).length > 0) {
				defaultFilters = {
					...this.state.defaultFilters,
					...defaultFilters,
					all:{
						...this.state.defaultFilters.all,
						...defaultFilters.all
					},
					blastcust:{
						...defaultFilters.blastcust
					},
					blastbidash:{
						...defaultFilters.blastbidash
					}
				}
			} 
			let wsFilter = JSON.parse(JSON.stringify(defaultFilters.all));
			this.setState({allMaps: allMaps, defaultFilters: defaultFilters, filterPointer:wsFilter, workspaceFilters: wsFilter, groupablesTree: res.groupableTree}, () => {
				this.setupOnlineStores();
			});
		}, err => {
		})
		this.workspaceService.initialize(clientAccountId, res => {

			let openWorkspaces = this.state.openWorkspaces;
			let activeWorkspaceId = this.state.activeWorkspaceId;

			let allMaps = {
				...this.state.allMaps,
				kpiNamingMap: res.kpiNamingMap
			}

			 let defaultKpiOrder = res.defaultKpiOrder;


			// Format Workspaces into workable sections
			let tmpWorkspaces = []

			let pos = '';

			if (zzDataCache.account.userType === 0) {
				pos = zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].pos;
			} else {
				pos = JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].pos;
			}

			//if(pos.toLowerCase() === 'booker') {
			//Temporarily disable SALES BY DAY report
			if(false) {				
				// SBD Start
				let salesByDayWorkspace = {
					id: SystemWorkspaceIDs.SalesByDay,
					title: 'workspace-sales-by-day',
					isExport: false,
					isGrandTotals: false,
					details: this.salesByDayWorkspace().details,
					publishedDetails: this.salesByDayWorkspace().publishedDetails,
					canEdit: false,
					isSystem: true
				};

				let sbdRowRenderOrder = [];
				let sbdCardRenderOrder = [];
				let sbdUpdateWorkspaceForYOY = false;

				salesByDayWorkspace.details.rows.forEach(row => {
					sbdRowRenderOrder.push(row.rowId);
					row.cards.forEach(card => {
						if (card != null) {
							sbdCardRenderOrder.push(card.id);
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });
				
									return r;
								}, [])
								sbdUpdateWorkspaceForYOY = true;
							}
						}
					})
				});
				
				salesByDayWorkspace.publishedDetails.rows.forEach(row => {
					if (!sbdRowRenderOrder.includes(row.rowId)) {
						sbdRowRenderOrder.push(row.rowId);
					}
					row.cards.forEach(card => {
						if (card != null && !sbdCardRenderOrder.includes(card.id)) {
							sbdCardRenderOrder.push(card.id)
						}
						if (card != null) {
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });
				
									return r;
								}, [])
								sbdUpdateWorkspaceForYOY = true;
							}
						}
					})
				});
				
				if (sbdUpdateWorkspaceForYOY) {
					this.saveWorkspace(salesByDayWorkspace, () => {
						console.log("workspace updated successfully!");
					});
				}
				salesByDayWorkspace.rowRenderOrder = sbdRowRenderOrder;
				salesByDayWorkspace.cardRenderOrder = sbdCardRenderOrder			

				tmpWorkspaces.push(salesByDayWorkspace);
				// SBD End
			} else if (this.props.isAaBiDashboardOnly || this.props.isAaBiDashboardEnabled) {
			// Bi Visits Start
				let biVisitsWorkspace = {
					id: SystemWorkspaceIDs.Visits,
					title: 'workspace-bi-visits',
					isExport: false,
					isGrandTotals: false,
					details: this.biVisitsWorkspace().details,
					publishedDetails: this.biVisitsWorkspace().publishedDetails,
					canEdit: false
				};

				let bivRowRenderOrder = [];
				let bivCardRenderOrder = [];
				let bivUpdateWorkspaceForYOY = false;

				biVisitsWorkspace.details.rows.forEach(row => {
					bivRowRenderOrder.push(row.rowId);
					row.cards.forEach(card => {
						if (card != null) {
							bivCardRenderOrder.push(card.id);
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });
				
									return r;
								}, [])
								bivUpdateWorkspaceForYOY = true;
							}
						}
					})
				});
				
				biVisitsWorkspace.publishedDetails.rows.forEach(row => {
					if (!bivRowRenderOrder.includes(row.rowId)) {
						bivRowRenderOrder.push(row.rowId);
					}
					row.cards.forEach(card => {
						if (card != null && !bivCardRenderOrder.includes(card.id)) {
							bivCardRenderOrder.push(card.id)
						}
						if (card != null) {
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });
				
									return r;
								}, [])
								bivUpdateWorkspaceForYOY = true;
							}
						}
					})
				});

				biVisitsWorkspace.details['isAABIDash'] = true;
				biVisitsWorkspace.publishedDetails['isAABIDash'] = true;

				if (bivUpdateWorkspaceForYOY) {
					this.saveWorkspace(biVisitsWorkspace, () => {
						console.log("Visits workspace updated successfully!");
					});
				}
				biVisitsWorkspace.rowRenderOrder = bivRowRenderOrder;
				biVisitsWorkspace.cardRenderOrder = bivCardRenderOrder			

				tmpWorkspaces.push(biVisitsWorkspace);
				openWorkspaces.push(biVisitsWorkspace.id);
				activeWorkspaceId = biVisitsWorkspace.id;
			// Bi Visits End

			// Bi Autopays Start
				let biAutopaysWorkspace = {
					id: SystemWorkspaceIDs.Autopays,
					title: 'workspace-bi-autopays',
					isExport: false,
					isGrandTotals: false,
					details: this.biAutopaysWorkspace().details,
					publishedDetails: this.biAutopaysWorkspace().publishedDetails,
					canEdit: false
				};

				let biaRowRenderOrder = [];
				let biaCardRenderOrder = [];
				let biaUpdateWorkspaceForYOY = false;

				biAutopaysWorkspace.details.rows.forEach(row => {
					biaRowRenderOrder.push(row.rowId);
					row.cards.forEach(card => {
						if (card != null) {
							biaCardRenderOrder.push(card.id);
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });
				
									return r;
								}, [])
								biaUpdateWorkspaceForYOY = true;
							}
						}
					})
				});
				
				biAutopaysWorkspace.publishedDetails.rows.forEach(row => {
					if (!biaRowRenderOrder.includes(row.rowId)) {
						biaRowRenderOrder.push(row.rowId);
					}
					row.cards.forEach(card => {
						if (card != null && !biaCardRenderOrder.includes(card.id)) {
							biaCardRenderOrder.push(card.id)
						}
						if (card != null) {
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });
				
									return r;
								}, [])
								biaUpdateWorkspaceForYOY = true;
							}
						}
					})
				});


				biAutopaysWorkspace.details['isAABIDash'] = true;
				biAutopaysWorkspace.publishedDetails['isAABIDash'] = true;
				if (biaUpdateWorkspaceForYOY) {
					this.saveWorkspace(biAutopaysWorkspace, () => {
						console.log("Autopays workspace updated successfully!");
					});
				}
				biAutopaysWorkspace.rowRenderOrder = biaRowRenderOrder;
				biAutopaysWorkspace.cardRenderOrder = biaCardRenderOrder			

				tmpWorkspaces.push(biAutopaysWorkspace);
				openWorkspaces.push(biAutopaysWorkspace.id);
			// Bi Autopays End

			// BI Sales Start
				let biSalesWorkspace = {
					id: SystemWorkspaceIDs.Sales,
					title: 'workspace-bi-sales',
					isExport: false,
					isGrandTotals: false,
					details: this.biSalesWorkspace().details,
					publishedDetails: this.biSalesWorkspace().publishedDetails,
					canEdit: false
				};

				let bisRowRenderOrder = [];
				let bisCardRenderOrder = [];
				let bisUpdateWorkspaceForYOY = false;

				biSalesWorkspace.details.rows.forEach(row => {
					bisRowRenderOrder.push(row.rowId);
					row.cards.forEach(card => {
						if (card != null) {
							bisCardRenderOrder.push(card.id);
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });

									return r;
								}, [])
								bisUpdateWorkspaceForYOY = true;
							}
						}
					})
				});

				biSalesWorkspace.publishedDetails.rows.forEach(row => {
					if (!bisRowRenderOrder.includes(row.rowId)) {
						bisRowRenderOrder.push(row.rowId);
					}
					row.cards.forEach(card => {
						if (card != null && !bisCardRenderOrder.includes(card.id)) {
							bisCardRenderOrder.push(card.id)
						}
						if (card != null) {
							if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
								card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
									r.push({ metric: e, isYOY: false });

									return r;
								}, [])
								bisUpdateWorkspaceForYOY = true;
							}
						}
					})
				});


				biSalesWorkspace.details['isAABIDash'] = true;
				biSalesWorkspace.publishedDetails['isAABIDash'] = true;
				if (bisUpdateWorkspaceForYOY) {
					this.saveWorkspace(biSalesWorkspace, () => {
						console.log("Sales workspace updated successfully!");
					});
				}
				biSalesWorkspace.rowRenderOrder = bisRowRenderOrder;
				biSalesWorkspace.cardRenderOrder = bisCardRenderOrder			

				tmpWorkspaces.push(biSalesWorkspace);
				openWorkspaces.push(biSalesWorkspace.id);
			//BI Sales End
			this.saveOpenWorkspacesLocal(openWorkspaces);
			}

			if(!this.props.isAaBiDashboardOnly) {
				res.workspaces.forEach(workspace => {
					try {
						let tmpWorkspace = {
							id: workspace.workspaceId,
							title: workspace.workspaceName,
							isExport: false,
							details: workspace.jsonSeed === "" ? this.blankWorkspace().details : JSON.parse(workspace.jsonSeed),
							publishedDetails: workspace.publishedJsonSeed === "" ? this.blankWorkspace().publishedDetails : JSON.parse(workspace.publishedJsonSeed),
							canEdit: workspace.canEdit
						}
	
						let rowRenderOrder = [];
						let cardRenderOrder = [];
						let updateWorkspaceForYOY = false;
						tmpWorkspace.details.rows.forEach(row => {
							rowRenderOrder.push(row.rowId);
							row.cards.forEach(card => {
								if (card != null) {
									cardRenderOrder.push(card.id);
									if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
										card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
											r.push({ metric: e, isYOY: false });
	
											return r;
										}, [])
										updateWorkspaceForYOY = true;
									}
								}
							})
						});
						tmpWorkspace.publishedDetails.rows.forEach(row => {
							if (!rowRenderOrder.includes(row.rowId)) {
								rowRenderOrder.push(row.rowId);
							}
							row.cards.forEach(card => {
								if (card != null && !cardRenderOrder.includes(card.id)) {
									cardRenderOrder.push(card.id)
								}
								if (card != null) {
									if (card.selectedMetrics.length > 0 & !card.selectedMetrics.some(x => x.isYOY === false) & !card.selectedMetrics.some(x => x.isYOY === true)) {
										card.selectedMetrics = card.selectedMetrics.reduce((r, e) => {
											r.push({ metric: e, isYOY: false });
	
											return r;
										}, [])
										updateWorkspaceForYOY = true;
									}
								}
							})
						});
	
						if (updateWorkspaceForYOY) {
							this.saveWorkspace(tmpWorkspace, () => {
								console.log("workspace updated successfully!");
							});
						}
						tmpWorkspace.rowRenderOrder = rowRenderOrder;
						tmpWorkspace.cardRenderOrder = cardRenderOrder;
	
						tmpWorkspaces.push(tmpWorkspace);
					} catch (ex) {
						console.log(ex)
					}
				})
			}
			
			// Setup time filter to default to the current month to date from CA calendar
			let timeFilter = this.state.timeFilter;
			res.calendarSpread.months.forEach(cal => {
				if (timeFilter.toDate >= cal.start && timeFilter.toDate <= cal.end) {
					timeFilter.fromDate = cal.start;
				}
			});

			// Card Metric Limits
			let cardMetricLimits = res.cardMetricLimits;


			this.setState({
				allMaps: allMaps,
				allKpiOptions: res.allKpiOptions,
				metricDefinitions: res.metricDefinitions,
				calendarSpread: res.calendarSpread,
				workspaces: tmpWorkspaces,
				openWorkspaces: openWorkspaces,
				cardMetricLimits: cardMetricLimits,
				defaultGroupings: res.defaultGroupings ? res.defaultGroupings : this.state.defaultGroupings,
				dataLastUpdate: res.lastUpdate,

				defaultKpiOrder: defaultKpiOrder,

				timeFilter: timeFilter,
				activeWorkspaceId: activeWorkspaceId
				// activeWorkspace: this.state.workspaces[0] // TODO: make correct choice from api
			}, () => {
				this.props.loadingOff();
				this.setupLongDates();

				this.pullDataByCards();
				this.pullLongDataByCards();
			});
		}, err => {
			alert("An error occurred. Please try again.")
			this.props.loadingOff();
		});

		this.workspaceService.getUsersByUsersClientAccount(data => {
			//this.state.workspaceUsers = data.users; //wtf? How did this shit work?
			this.setState({
				workspaceUsers: data.users
			});
		}, err => {
			console.log(err);
		});
	}

	fetchOnlineStores() {
		let accountInfo = window.zzDataCache.initAccount();
		let onlineStores = [];
		if(this.props.isOnlineStoreEnabled) {
			if(accountInfo.userType === 0) {
				let clientAccIx = +(zzDataCache.settings.selectedClientAccountIndex);
				let locations = accountInfo.clientAccountList[clientAccIx].locations;
				locations.forEach(location => {
					if(location.isOnlineLocation !== undefined && location.isOnlineLocation) {
						onlineStores.push(location.clusterID.toString());
					}
				})
			} else {
				let locations = accountInfo.clientAccountList[0].locations;
				locations.forEach(location => {
					if(location.isOnlineLocation !== undefined && location.isOnlineLocation) {
						onlineStores.push(location.clusterID.toString());
					}
				})
			}
		}
		return onlineStores;
	}

	setupOnlineStores(allMaps) {
		if(this.props.isOnlineStoreEnabled) {
			let onlineStores = this.fetchOnlineStores();
			let defaultFilters = {
				all : {
					onlineStoreId: [...onlineStores]
				},
				blast: {
					onlineStoreId: [...onlineStores]
				},
				blastcust: {
					onlineStoreId: [...onlineStores]
				},
				blastbidash: {
					onlineStoreId: [...onlineStores]
				}
			}
			defaultFilters = this.setupFilters(defaultFilters, allMaps);
			if(Object.keys(this.state.defaultFilters).length > 0) {
				defaultFilters = {
					...this.state.defaultFilters,
					...defaultFilters,
					all:{
						...this.state.defaultFilters.all,
						...defaultFilters.all
					},
					blast:{
						...this.state.defaultFilters.blast,
						...defaultFilters.blast
					},
					blastcust:{
						...this.state.defaultFilters.blastcust,
						...defaultFilters.blastbidash
					},
					blastbidash:{
						...this.state.defaultFilters.blastbidash,
						...defaultFilters.blastbidash
					}
					
				}
			} 
			let wsFilter = JSON.parse(JSON.stringify(defaultFilters.all));
			this.setState({defaultFilters: defaultFilters, filterPointer:wsFilter, workspaceFilters: wsFilter})
		}
	}

	setupFilters(defaultFilters, allMaps) {

		let tmpAllFilters = Object.keys(defaultFilters.all).reduce((r, e) => {

			let label = e, map = null,
				options = Object.values(defaultFilters.all[e]),
				selected = Object.values(defaultFilters.all[e]);

			switch (e) {
				case "brandId":
					label = "Brand";
					map = "brandMap";
					break;
				case "employeeUniqueName":
					label = "Employee";
					map = "employeeMap";
					break;
				case "productCategoryId":
					label = "Product Category";
					map = "productCategoryMap";
					break;
				case "productId":
					label = "Product";
					map = "productMap";
					break;
				case "distirctId":
					label = "District";
					map = "districtMap";
					break;
				case "productSubCategoryId":
					label = "Product Subcategory";
					map = "productSubCategoryMap";
					break;
				case "storeId":
					label = "Location";
					map = "storeMap";
					break;
				case "treatmentCategoryId":
					label = "Treatment Category";
					map = "treatmentCategoryMap";
					break;
				case "treatmentId":
					label = "Treatment";
					map = "treatmentMap";
					break;
				case "treatmentSubCategoryId":
					label = "Treatment Subcategory";
					map = "treatmentSubCategoryMap";
					break;
				case "onlineStoreId":
					label = "Online Stores";
					map = "storeMap";
					break;
			}

			r[e] = {
				label: label,
				map: map,
				options: options,
				selected: selected
			}

			return r;
		}, {});

		let tmpDefaultFilters = Object.keys(defaultFilters).reduce((r, e) => {

			if (e != "all") {
				r[e] = Object.keys(defaultFilters[e]).reduce((r2, e2) => {
					if (tmpAllFilters[e2]) {
						r2[e2] = tmpAllFilters[e2];
					} else if (e === 'blastprod' || e === 'blasttreat') {
						switch (e2) {
							case "categoryId": r2[e2] = tmpAllFilters[e === 'blastprod' ? "productCategoryId" : "treatmentCategoryId"];
								break;
							case "subCategoryId": r2[e2] = tmpAllFilters[e === 'blastprod' ? "productSubCategoryId" : "treatmentSubCategoryId"];
								break;
						}
					}
					return r2;
				}, {})
			} else {
				r[e] = tmpAllFilters;
			}

			return r;
		}, {})
		return tmpDefaultFilters;
	}

	setupLongDates() {
		let calendarSpread = this.state.calendarSpread;
		let timeFilter = this.state.timeFilter;

		let tmpCals = { days: [], weeks: [], months: [], quarters: [], years: [] };
		let longDates = [];

		Object.keys(calendarSpread).forEach(key => {
			if (key != 'all') {
				calendarSpread[key].forEach(calPiece => {
					if (calPiece.start >= timeFilter.fromDate && calPiece.end <= timeFilter.toDate) {
						tmpCals[key].push(calPiece);
					}
				})
			}
		});
		tmpCals.days = dateIndexRange(timeFilter.fromDate, timeFilter.toDate).reduce((r, e) => {
			r.push({ start: e, end: e });
			return r;
		}, []);

		if (tmpCals.years.length >= 2) {
			longDates = tmpCals.years;
		} else if (tmpCals.quarters.length >= 5) {
			longDates = tmpCals.quarters;
		} else if (tmpCals.months.length >= 6) {
			longDates = tmpCals.months;
		} else if (tmpCals.weeks.length >= 5) {
			longDates = tmpCals.weeks;
		} else if (tmpCals.days.length <= 15) {
			longDates = tmpCals.days;
		} else {
			let tmpIntervals = {};
			for (var i = 1; i <= 4; i++) {
				tmpIntervals[i] = Math.floor(tmpCals.days.length / i);
			}
			let finalInterval = parseInt(_.sortBy(Object.keys(tmpIntervals).reduce((r, e) => {
				r.push({ interval: e, value: Math.abs(10 - tmpIntervals[e]) })
				return r;
			}, []), item => item.value)[0].interval);

			let finalDays = []
			for (var i = 0; i < tmpCals.days.length; i += finalInterval) {
				finalDays.push({
					start: tmpCals.days[i].start,
					end: tmpCals.days[i + finalInterval - 1] ? tmpCals.days[i + finalInterval - 1].end : null
				})
			}
			if (finalDays.length > 0 && finalDays[finalDays.length - 1].end === null) {
				finalDays[finalDays.length - 1].end = timeFilter.toDate;
			}

			longDates = finalDays;
		}

		this.longDates = longDates;
	}

	pullDataByCards() {

		//this.props.loadingOn(() => {

		let kpiColumns = {}

		this.state.workspaces.forEach(workspace => {
			workspace.details.rows.forEach(row => {
				row.cards.forEach(card => {
					if (card != null && card.chartType != "line") {
						let key = card.dataSet.toUpperCase();
						if (!kpiColumns[key]) {
							kpiColumns[key] = [];
						}
						card.selectedMetrics.forEach(obj => {
							if (!kpiColumns[key].includes(obj.metric)) {
								kpiColumns[key].push(obj.metric);
							}
						});
					}
				});
			});
			workspace.publishedDetails.rows.forEach(row => {
				row.cards.forEach(card => {
					if (card != null && card.chartType != "line") {
						let key = card.dataSet.toUpperCase();
						if (!kpiColumns[key]) {
							kpiColumns[key] = [];
						}
						card.selectedMetrics.forEach(obj => {
							if (!kpiColumns[key].includes(obj.metric)) {
								kpiColumns[key].push(obj.metric);
							}
						});
					}
				});
			});
		});

		this.lastKpiColumns = kpiColumns;
		if(this.lastKpiColumns !== undefined) {
			if(this.lastKpiColumns.BLASTBIDASH !== undefined) {
				this.lastKpiColumns.BLASTBIDASH.push('AvailableHours');
				this.lastKpiColumns.BLASTBIDASH.push('FloorHours');
			}
		}

		let payload = {};
		let cardLoading = {
			...this.state.dataLoading
		}
		Object.keys(kpiColumns).forEach(kpiColumn => {
			if (zzDataCache.account.userType === 0) {
				payload = {
					companyId: zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].companyID,
					fromDate: this.findSuitableFromDate(),
					toDate: this.state.timeFilter.toDate,
					kpiColumns: {[kpiColumn]:[...kpiColumns[kpiColumn]]}
				}
			} else {
				payload = {
					companyId: JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].companyID,
					fromDate: this.findSuitableFromDate(),
					toDate: this.state.timeFilter.toDate,
					kpiColumns: {[kpiColumn]:[...kpiColumns[kpiColumn]]}
				}
			}
			switch(kpiColumn.toLowerCase()) {
				case 'blast':
					cardLoading = {
						...cardLoading,
						blast:true
					}
					this.setState({dataLoading:cardLoading});
					this.workspaceService.getData(payload, data => {
						let tmpData = {
							...this.state.allData,
							blast: data.locationBlastMetrics
						}
						let tmpLoading = {
							...this.state.dataLoading,
							blast: false
						}
						this.setState({ allData: tmpData, dataLoading: tmpLoading, cardLoading: null}, () => {
						//this.props.loadingOff();
						});
					}, err => {
						console.log(err);
						this.setState({dataLoading:{...this.state.dataLoading,blast:false}, cardLoading: null});
						alert("There was an error while fetching data.")
						this.props.loadingOff()
					})
					break;
				case 'blastp':
					cardLoading = {
						...cardLoading,
						blastp:true
					}
					this.setState({dataLoading:cardLoading});
					this.workspaceService.getData(payload, data => {
						let tmpData = {
							...this.state.allData,
							blastp: data.employeeBlastMetrics
						}
						let tmpLoading = {
							...this.state.dataLoading,
							blastp: false
						}
						this.setState({ allData: tmpData, dataLoading: tmpLoading, cardLoading: null}, () => {
						//this.props.loadingOff();
						});
					}, err => {
						console.log(err);
						this.setState({dataLoading:{...this.state.dataLoading,blastp:false}, cardLoading: null});
						alert("There was an error while fetching data.")
						this.props.loadingOff()
					})
					break;
				case 'blastprod':
					cardLoading = {
						...cardLoading,
						blastprod:true
					}
					this.setState({dataLoading:cardLoading});
					this.workspaceService.getData(payload, data => {
						let tmpData = {
							...this.state.allData,
							blastprod: data.products
						}
						let tmpLoading = {
							...this.state.dataLoading,
							blastprod: false
						}
						this.setState({ allData: tmpData, dataLoading: tmpLoading, cardLoading: null}, () => {
						//this.props.loadingOff();
						});
					}, err => {
						console.log(err);
						this.setState({dataLoading:{...this.state.dataLoading,blastprod:false}, cardLoading: null});
						alert("There was an error while fetching data.")
						this.props.loadingOff()
					})
					break;
				case 'blastcust':
					cardLoading = {
						...cardLoading,
						blastcust:true
					}
					this.setState({dataLoading:cardLoading});
					this.workspaceService.getData(payload, data => {
						let tmpData = {
							...this.state.allData,
							blastcust: data.consumerBlastMetrics
						}
						let tmpLoading = {
							...this.state.dataLoading,
							blastcust: false
						}
						this.setState({ allData: tmpData, dataLoading: tmpLoading, cardLoading: null}, () => {
						//this.props.loadingOff();
						});
					}, err => {
						console.log(err);
						this.setState({dataLoading:{...this.state.dataLoading,blastcust:false}, cardLoading: null});
						alert("There was an error while fetching data.")
						this.props.loadingOff()
					})	
					break;
				case 'blasttreat':
					cardLoading = {
						...cardLoading,
						blasttreat:true
					}
					this.setState({dataLoading:cardLoading});
					this.workspaceService.getData(payload, data => {
						let tmpData = {
							...this.state.allData,
							blasttreat: data.treatments
						}
						let tmpLoading = {
							...this.state.dataLoading,
							blasttreat: false
						}
						this.setState({ allData: tmpData, dataLoading: tmpLoading, cardLoading: null}, () => {
						//this.props.loadingOff();
						});
					}, err => {
						console.log(err);
						this.setState({dataLoading:{...this.state.dataLoading,blasttreat:false}, cardLoading: null});
						alert("There was an error while fetching data.")
						this.props.loadingOff()
					})	
					break;
				case 'blastsbd':
					cardLoading = {
						...cardLoading,
						blastsbd:true
					}
					this.setState({dataLoading:cardLoading});
					this.workspaceService.getData(payload, data => {
						let tmpData = {
							...this.state.allData,
							blastsbd: data.salesByDay
						}
						let tmpLoading = {
							...this.state.dataLoading,
							blastsbd: false
						}
						this.setState({ allData: tmpData, dataLoading: tmpLoading, cardLoading: null}, () => {
						//this.props.loadingOff();
						});
					}, err => {
						console.log(err);
						this.setState({dataLoading:{...this.state.dataLoading,blastsbd:false}, cardLoading: null});
						alert("There was an error while fetching data.")
						this.props.loadingOff()
					})	
					break;
				case 'blastbidash':
					cardLoading = {
						...cardLoading,
						blastbidash:true
					}
					this.setState({dataLoading:cardLoading});
					this.workspaceService.getData(payload, data => {
						let tmpData = {
							...this.state.allData,
							blastbidash: data.biDashboards
						}
						let tmpLoading = {
							...this.state.dataLoading,
							blastbidash: false
						}
						this.setState({ allData: tmpData, dataLoading: tmpLoading, cardLoading: null}, () => {
						//this.props.loadingOff();
						});
					}, err => {
						console.log(err);
						this.setState({dataLoading:{...this.state.dataLoading,blastbidash:false}, cardLoading: null});
						alert("There was an error while fetching data.")
						this.props.loadingOff()
					})	
					break;
			}
		})
	}

	pullLongDataByCards() {
		let kpiColumns = {}

		this.state.workspaces.forEach(workspace => {
			workspace.details.rows.forEach(row => {
				row.cards.forEach(card => {
					if (card != null && card.chartType === "line") {
						let key = card.dataSet.toUpperCase();
						if (!kpiColumns[key]) {
							kpiColumns[key] = [];
						}
						card.selectedMetrics.forEach(obj => {
							if (!kpiColumns[key].includes(obj.metric)) {
								kpiColumns[key].push(obj.metric);
							}
						});
					}
				});
			});
			workspace.publishedDetails.rows.forEach(row => {
				row.cards.forEach(card => {
					if (card != null && card.chartType === "line") {
						let key = card.dataSet.toUpperCase();
						if (!kpiColumns[key]) {
							kpiColumns[key] = [];
						}
						card.selectedMetrics.forEach(obj => {
							if (!kpiColumns[key].includes(obj.metric)) {
								kpiColumns[key].push(obj.metric);
							}
						});
					}
				});
			});
		});

		this.lastLongKpiColumns = kpiColumns;

		this.setState({
			longData: {
				blast: [],
				blastp: [],
				blastcust: [],
				blastprod: [],
				blasttreat: [],
				blastsbd: [],
				blastbidash: []
			}
		}, () => {
			this.longDates.forEach(date => {

				let payload = {};
				if (zzDataCache.account.userType === 0) {
					payload = {
						companyId: zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].companyID,
						fromDate: date.start,
						toDate: date.end,
						kpiColumns: kpiColumns,
						IsLongData: zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].pos.toLowerCase() === 'mindbody' || zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].pos.toLowerCase() === 'booker' ? true : false
					}
				} else {
					payload = {
						companyId: JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].companyID,
						fromDate: date.start,
						toDate: date.end,
						kpiColumns: kpiColumns,
						IsLongData: JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].pos.toLowerCase() === 'mindbody' || JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].pos.toLowerCase() === 'booker' ? true : false
					}
				}
				if(this.state.cardLoading === null) {
					this.setState({ longDataLoading: true });
				}

				if (Object.keys(payload.kpiColumns).length > 0) {
					this.workspaceService.getData(payload, data => {

						let tmpData = {
							blast: data.locationBlastMetrics,
							blastp: data.employeeBlastMetrics,
							blastprod: data.products,
							blastcust: data.consumerBlastMetrics,
							blasttreat: data.treatments,
							blastsbd: data.salesByDays,
							blastbidash: data.biDashboards
						}

						let longData = this.state.longData;

						longData.blast = longData.blast.concat(tmpData.blast).sort((a, b) => a.dateIndex > b.dateIndex ? 1 : -1);
						longData.blastp = longData.blastp.concat(tmpData.blastp).sort((a, b) => a.dateIndex > b.dateIndex ? 1 : -1);
						longData.blastprod = longData.blastprod.concat(tmpData.blastprod).sort((a, b) => a.dateIndex > b.dateIndex ? 1 : -1);
						longData.blastcust = longData.blastcust.concat(tmpData.blastcust).sort((a, b) => a.dateIndex > b.dateIndex ? 1 : -1);
						longData.blasttreat = longData.blasttreat.concat(tmpData.blasttreat).sort((a, b) => a.dateIndex > b.dateIndex ? 1 : -1);
						longData.blastsbd = longData.blastsbd.concat(tmpData.blastsbd).sort((a, b) => a.dateIndex > b.dateIndex ? 1 : -1);
						longData.blastbidash = longData.blastbidash.concat(tmpData.blastbidash).sort((a, b) => a.dateIndex > b.dateIndex ? 1 : -1);

						let longDataLoading = false;
						this.setState({ longData: longData, longDataLoading: longDataLoading, cardLoading: null}, () => {
							// console.log(longData)
						});
					}, err => {
						this.setState({longDataLoading:false, cardLoading: null});
						alert("There was an error while fetching data.")
						console.log(err);
					});
				}
			})
		})
	}

	setTimeRange(fromDateIndex, toDateIndex) {

		let timeFilter = this.state.timeFilter;
		timeFilter.fromDate = fromDateIndex;
		timeFilter.toDate = toDateIndex;

		this.setState({
			timeFilter: timeFilter,
			timeOpen: false,
			activeFilter: null
		}, () => {
			this.setupLongDates();
			this.pullDataByCards();
			this.pullLongDataByCards();
		})
	}

	findSuitableFromDate() {
		let fromDate = this.state.timeFilter.fromDate;
		let toDate = this.state.timeFilter.toDate;

		// Until we can get more ranges faster, we're always gonna use custom ranges
		return fromDate

		if (fromDate === toDate) {
			return 0;
		}

		let rzero = false;
		this.state.calendarSpread.all.forEach(calspread => {
			if (toDate >= calspread.start && toDate <= calspread.end && fromDate === calspread.start) {
				rzero = true;
			}
		})

		return rzero ? 0 : fromDate;
	}

	setLeftBarOpen(status) {
		this.setState({ leftBarOpen: status, activeFilter: null, timeOpen: false, });
		
	}

	setTimeOpen(status) {
		this.setState({ timeOpen: status, activeFilter: null });
	}

	setActiveFilter(key) {
		this.setState({ activeFilter: this.state.activeFilter === key ? null : key, timeOpen: false, });
	}

	makeFilterSelection(value, filterName) {
		let filters = this.state.filterPointer;

		if (filters[filterName] != undefined) {
			let filter = filters[filterName];

			if (filter.options.length > 0 && typeof filter.options[0] === "object") {
				filter.options.forEach(op => {
					if (op.options.includes(value)) {
						if (op.selected.includes(value)) {
							op.selected.splice(op.selected.indexOf(value), 1);
						} else {
							op.selected.push(value);
						}
					}
				})
			}

			if (filter.selected.includes(value)) {
				filter.selected.splice(filter.selected.indexOf(value), 1)
			} else {
				filter.selected.push(value);
			}
		}

		this.setState({ filters: filters });
	}

	selectAllFilters(filterName, options) {
		let filters = this.state.filterPointer;
		if (filters[filterName] != undefined) {
			let filter = filters[filterName];
			options.forEach(option => {
				if (!filter.selected.includes(option)) {
					filter.selected = filter.selected.concat(option)
				}
			})
		}
		this.setState({ filters: filters })
	}

	resetFilters() {
		let filters = this.state.filterPointer;
		Object.keys(filters).forEach(key => {
			this.selectAllFilters(key, filters[key].options);
		})
	}

	deSelectAllFilters(filterName, options) {
		let filters = this.state.filterPointer;
		if (filters[filterName] != undefined) {
			let filter = filters[filterName];
			options.forEach(option => {
				if (filter.selected.indexOf(option) >= 0) {
					const idx = filter.selected.indexOf(option);
					filter.selected = [...filter.selected.slice(0, idx), ...filter.selected.slice(idx + 1)];
				}
			})
		}
		this.setState({ filters: filters })
	}

	makeFilterMajorSelection(value, filterName) {
		let filters = this.state.filterPointer;

		if (filters[filterName] != undefined) {
			let filter = filters[filterName];

			let changeList = []
			let changeAdd = true;

			// filter.selected = [];
			filter.options.forEach(op => {
				if (op.value === value) {
					changeList = op.options;
					if (op.selected.length < op.options.length) {
						changeList.forEach(sub => { if (!op.selected.includes(sub)) { op.selected.push(sub); } })
					} else {
						op.selected = [];
						changeAdd = false;
					}
				}
			});

			if (changeAdd) {
				changeList.forEach(ch => {
					if (!filter.selected.includes(ch)) {
						filter.selected.push(ch);
					}
				})
			} else {
				changeList.forEach(ch => {
					if (filter.selected.includes(ch)) {
						filter.selected.splice(filter.selected.indexOf(ch), 1);
					}
				})
			}
		}

		this.setState({ filters: filters });
	}

	expandFilterMajor(value) {
		let expandedFilterMajors = this.state.expandedFilterMajors;

		if (expandedFilterMajors.includes(value)) {
			expandedFilterMajors.splice(expandedFilterMajors.indexOf(value), 1)
		} else {
			expandedFilterMajors.push(value);
		}

		this.setState({ expandedFilterMajors: expandedFilterMajors })
	}

	selectWorkspace(workspaceId) {
		if (this.state.activeWorkspaceId != workspaceId) {
			this.setState({ activeWorkspaceId: workspaceId }, () => {
				this.workspaceService.getWorkspaceShareData(this.state.activeWorkspaceId, data => {
					this.setState({
						workspaceUserRoles: data.workspaceUserRoles,
						workspaceUsers: data.workspaceUsers,
						workspaceDefault: data.workspaceDefault
					});
				}, err => {
					console.log(err);
				});
			})
		}
	}

	goToDesignMode(workspaceId) {

		this.setState({
			activeWorkspaceId: workspaceId,
			isDesignMode: true,
		});
	}

	quitDesignMode() {
		this.setState({ isDesignMode: false })
	}

	selectMetric(metricId) {
		let metricFilter = this.state.metricFilter;

		if (metricFilter.mode === "radio") {
			metricFilter.selectedMetrics = [metricId];
		} else if (metricFilter.mode === "check") {
			if (metricFilter.selectedMetrics.includes(metricId)) {
				metricFilter.selectedMetrics.splice(metricFilter.selectedMetrics.indexOf(metricId), 1);
			} else {
				metricFilter.selectedMetrics.push(metricId);
			}
		}

		let activeCard = this.state.activeCard;
		if (activeCard != null) {
			activeCard.selectedMetrics = metricFilter.selectedMetrics
		}

		this.setState({ metricFilter: metricFilter, activeCard: activeCard });
	}

	selectLocation(locationId) {
		let locationFilter = this.state.locationFilter;

		if (locationFilter.mode === "radio") {
			locationFilter.selectedLocations = [locationId];
		} else if (locationFilter.mode === "check") {
			if (locationFilter.selectedLocations.includes(locationId)) {
				locationFilter.selectedLocations.splice(locationFilter.selectedLocations.indexOf(locationId), 1);
			} else {
				locationFilter.selectedLocations.push(locationId);
			}
		}

		let activeCard = this.state.activeCard;
		if (activeCard != null) {
			activeCard.selectedLocations = locationFilter.selectedLocations
		}

		this.setState({ locationFilter: locationFilter, activeCard: activeCard });
	}

	selectDistrict(districtId) {
		let locationFilter = this.state.locationFilter;

		if (locationFilter.mode === 'check') {
			let districtLocations = this.state.districtLocationMap[districtId];
			let foundCount = 0;
			districtLocations.forEach(disloc => {
				if (locationFilter.selectedLocations.includes(disloc)) {
					foundCount++;
				}
			});
			if (foundCount === 0) {
				districtLocations.forEach(disloc => {
					locationFilter.selectedLocations.push(disloc);
				});
			} else if (foundCount === districtLocations.length) {
				districtLocations.forEach(disloc => {
					locationFilter.selectedLocations.splice(locationFilter.selectedLocations.indexOf(disloc), 1);
				});
			} else {
				districtLocations.forEach(disloc => {
					if (!locationFilter.selectedLocations.includes(disloc)) {
						locationFilter.selectedLocations.push(disloc);
					}
				});
			}
		}

		let activeCard = this.state.activeCard;
		if (activeCard != null) {
			activeCard.selectedLocations = locationFilter.selectedLocations
		}

		this.setState({ locationFilter: locationFilter, activeCard: activeCard });
	}

	saveOpenWorkspacesLocal(openWorkspaces) {
		localStorage.setItem('open-workspaces', JSON.stringify(openWorkspaces))
	}

	saveWorkspace(workspace, callback) {

		if (workspace.id === SystemWorkspaceIDs.SalesByDay || workspace.id === SystemWorkspaceIDs.Visits || workspace.id === SystemWorkspaceIDs.Autopays || workspace.id === SystemWorkspaceIDs.Sales) {
				this.forceUpdate();
				if (callback != null && callback != undefined && typeof callback === "function") {
					callback();
				}
		} else {
			let formattedWorkspace = {
				workspaceId: workspace.id,
				workspaceName: workspace.title,
				// isPublished: workspace.isPublished,
				jsonSeed: JSON.stringify(workspace.details),
				publishedJsonSeed: JSON.stringify(workspace.publishedDetails),
				favorite: workspace.favorite != undefined ? workspace.favorite : false
			}

			this.workspaceService.saveWorkspace(formattedWorkspace, res => {
				console.log(res)
				this.forceUpdate();
				if (callback != null && callback != undefined && typeof callback === "function") {
					callback();
				}
			}, err => {
				console.log(err)
				if (callback != null && callback != undefined && typeof callback === "function") {
					callback();
				}
			})
		}
	}

	createWorkspace() {
		let workspaces = this.state.workspaces;
		let openWorkspaces = this.state.openWorkspaces;

		let clientAccountId = '';

		if (zzDataCache.account.userType === 0) {
			if ((localStorage.getItem('zzSettings') !== null) && JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex !== undefined) {
				clientAccountId = '/' + zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].clientAccountId;
			}
			else {
				clientAccountId = null;
			}
		} else {
			clientAccountId = '/' + JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].clientAccountId;
		}

		this.workspaceService.createWorkspace(clientAccountId, res => {

			let tmpWorkspace = this.blankWorkspace();
			tmpWorkspace.id = res;
			let wsNum = workspaces.length + 1;
			tmpWorkspace.details.name = "Untitled (#" + wsNum + ")";
			tmpWorkspace.publishedDetails.name = "Untitled (#" + wsNum + ")";
			tmpWorkspace.canEdit = true;

			workspaces.push(tmpWorkspace);
			openWorkspaces.push(tmpWorkspace.id)

			this.saveOpenWorkspacesLocal(openWorkspaces);

			this.setState({
				workspaces: workspaces,
				activeWorkspaceId: tmpWorkspace.id,
				isDesignMode: true,
				openWorkspaces: openWorkspaces
			})

		}, err => {
			console.log(err)
		})
	}

	duplicateWorkspace(workspaceId) {
		let workspaces = this.state.workspaces;
		let openWorkspaces = this.state.openWorkspaces;

		let original = null;
		let originalIndex = -1;
		workspaces.forEach((ws, index) => {
			if (ws.id === workspaceId) {
				original = ws;
				originalIndex = index;
			}
		});

		if (original === null) {
			return;
		}

		let clientAccountId = '';

		if (zzDataCache.account.userType === 0) {
			if ((localStorage.getItem('zzSettings') !== null) && JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex !== undefined) {
				clientAccountId = '/' + zzDataCache.account.clientAccountList[JSON.parse(localStorage.getItem('zzSettings')).selectedClientAccountIndex].clientAccountId;
			}
			else {
				clientAccountId = null;
			}
		} else {
			clientAccountId = '/' + JSON.parse(localStorage.getItem('zzAccount')).clientAccountList[0].clientAccountId;
		}

		this.workspaceService.createWorkspace(clientAccountId, res => {

			let tmpWorkspace = JSON.parse(JSON.stringify(original));
			tmpWorkspace.id = res;
			tmpWorkspace.details.name = (tmpWorkspace.details.name + " - Copy").substring(0, 40);
			tmpWorkspace.publishedDetails.name = (tmpWorkspace.publishedDetails.name + " - Copy").substring(0, 40);
			tmpWorkspace.title = tmpWorkspace.details.name;
			tmpWorkspace.canEdit = true;
			let rowRender = [];
			let cardRender = [];
			let rows = [];
			tmpWorkspace.publishedDetails.rows.forEach((row) => {
				const newRowId = this.createRowId();
				let cards = [];
				row.rowId = newRowId;
				rowRender.push(newRowId);

				row.cards.forEach((card) => {
					if (card != null) {
						const newId = this.createRowId();
						card.id = newId;
						cardRender.push(newId);
						const scard = { ...card };
						cards.push(scard)
					} else {
						cards.push(null);
					}
				})
				const srow = {
					...row,
					cards: cards
				};
				rows.push(srow);
			});
			let updatedWorkspace = {
				...tmpWorkspace,
				rowRenderOrder: rowRender,
				cardRenderOrder: cardRender,
				details: {
					...tmpWorkspace.details,
					rows: rows
				},
				publishedDetails: {
					...tmpWorkspace.publishedDetails,
					rows: rows
				}
			}
			tmpWorkspace = JSON.parse(JSON.stringify(updatedWorkspace));

			workspaces.splice(originalIndex + 1, 0, tmpWorkspace);
			openWorkspaces.splice(openWorkspaces.indexOf(workspaceId) + 1, 0, tmpWorkspace.id);

			this.saveOpenWorkspacesLocal(openWorkspaces);

			this.setState({
				workspaces: workspaces,
				activeWorkspaceId: tmpWorkspace.id,
				isDesignMode: false,
				openWorkspaces: openWorkspaces
			}, () => {
				this.saveWorkspace(tmpWorkspace);
			})

		}, err => {
			console.log(err)
		})
	}

	deleteWorkspace(workspaceId) {
		let workspaces = this.state.workspaces;
		let openWorkspaces = this.state.openWorkspaces;

		this.workspaceService.deleteWorkspace(workspaceId, res => {

			if (openWorkspaces.includes(workspaceId)) {
				openWorkspaces.splice(openWorkspaces.indexOf(workspaceId), 1);
				this.saveOpenWorkspacesLocal(openWorkspaces)
			}

			for (var i = 0; i < workspaces.length; i++) {
				if (workspaces[i].id === workspaceId) {
					workspaces.splice(i, 1);
					break;
				}
			}

			this.setState({
				workspaces: workspaces,
				activeWorkspaceId: null,
				isDesignMode: false,
				openWorkspaces: openWorkspaces
			})

		}, err => {
			console.log(err);
		})
	}

	publishWorkspace() {
		let workspaces = this.state.workspaces;

		if (this.state.isPublishing) {
			return;
		}

		this.setState({ isPublishing: true }, () => {
			workspaces.forEach(workspace => {
				if (workspace.id === this.state.activeWorkspaceId) {

					workspace.details.lastSaved = moment().format("MM/DD/YYYY h:mm a z");
					workspace.publishedDetails = JSON.parse(JSON.stringify(workspace.details));

					this.saveWorkspace(workspace);
				}
			});

			this.setState({ workspaces: workspaces }, () => {
				setTimeout(() => {
					this.setState({ isPublishing: false })
				}, 1000);
			})
		});
	}

	restoreWorkspace() {
		let workspaces = this.state.workspaces;

		workspaces.forEach(workspace => {
			if (workspace.id === this.state.activeWorkspaceId) {
				workspace.details = JSON.parse(JSON.stringify(workspace.publishedDetails));
				this.saveWorkspace(workspace);
			}
		});

		this.setState({ workspaces: workspaces })
	}

	closeWorkspace(workspaceId) {
		let openWorkspaces = this.state.openWorkspaces;

		if (openWorkspaces.includes(workspaceId)) {
			openWorkspaces.splice(openWorkspaces.indexOf(workspaceId), 1);
		}

		this.saveOpenWorkspacesLocal(openWorkspaces);

		this.setState({
			openWorkspaces: openWorkspaces,
			activeWorkspaceId: workspaceId === this.state.activeWorkspaceId ? null : this.state.activeWorkspaceId
		})
	}

	closeAllWorkspaces() {

		this.saveOpenWorkspacesLocal([]);
		this.setState({ openWorkspaces: [], activeWorkspaceId: null })
	}

	openFavoriteWorkspaces(workspace) {
		let openWorkspaces = this.state.openWorkspaces;

		if(!openWorkspaces.includes(workspace.id)) {
			openWorkspaces.push(workspace.id);
		}
		this.saveOpenWorkspacesLocal(openWorkspaces);

		this.setState({ openWorkspaces: openWorkspaces })
	}

	toggleWorkspaceOpen(workspace) {
		let openWorkspaces = this.state.openWorkspaces;

		if (openWorkspaces.includes(workspace.id)) {
			openWorkspaces.splice(openWorkspaces.indexOf(workspace.id), 1);
		} else {
			openWorkspaces.push(workspace.id)
		}

		this.saveOpenWorkspacesLocal(openWorkspaces);

		this.setState({ openWorkspaces: openWorkspaces })
	}

	blankWorkspace() {
		let rowId = this.createRowId();
		return {
			id: 0,
			title: "Untitled",
			isExport: false,
			details: {
				name: "Untitled",
				description: "...",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						rowId: rowId,
						columns: 4,
						cards: [null, null, null, null]
					}
				]
			},
			publishedDetails: {
				name: "Untitled",
				description: "",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						rowId: rowId,
						columns: 4,
						cards: [null, null, null, null]
					}
				]
			},
			rowRenderOrder: [rowId],
			cardRenderOrder: []
		}
	}

	salesByDayWorkspace() {
		let rowId = "0000";
		return {
			id: 0,
			title: "Sales by Day",
			isExport: false,
			details: {
				name: "Sales by Day",
				description: "...",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						"rowId": "Row0",
						"columns": 4,
						"cards": [
							{
								"chartType": "table",
								"dataSet": "blastsbd",
								"filters": {

									"storeId": {
										"isAllSelected": true,
										"label": "Location",
										"map": "salesByDayMap",
										"options": [],
										"selected": []
									}
								},
								"isGroupable": true,
								"isGrandTotals" : false,
								"groupables": [
									"DateIndex",
									"StoreId"
								],
								"isLocked": true,
								"selectedMetrics": [
									"SalesByDayServiceSales",
									"SalesByDayProductSales",
									"SalesByDayGiftCardSales",
									"SalesByDaySeriesSales",
									"SalesByDayCancellationFees",
									"SalesByDayMembershipSales",
									"SalesByDayAdjustments",
									"SalesByDayGrossSales",
									"SalesByDayPrepaids",
									"SalesByDayRefunds",
									"SalesByDayNetSales"
								],
								"supportFields": [
									"DateIndex",
									"StoreName"
								],
								"title": "Sales By Day",
								"width": 4,
								"height": 2,
								"id": "00000"
							},
							null,
							null,
							null
						]
					}
				]
			},
			publishedDetails: {
				name: "Sales by Day",
				description: "",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						"rowId": "Row0",
						"columns": 4,
						"cards": [
							{
								"chartType": "table",
								"dataSet": "blastsbd",
								"filters": {
									"storeId": {
										"isAllSelected": true,
										"label": "Location",
										"map": "salesByDayMap",
										"options": [],
										"selected": []
									}
								},
								"isGroupable": true,
								"isGrandTotals" : false,
								"groupables": [
									"DateIndex",
									"StoreId"
								],
								"isLocked": true,
								"selectedMetrics": [
									"SalesByDayServiceSales",
									"SalesByDayProductSales",
									"SalesByDayGiftCardSales",
									"SalesByDaySeriesSales",
									"SalesByDayCancellationFees",
									"SalesByDayMembershipSales",
									"SalesByDayAdjustments",
									"SalesByDayGrossSales",
									"SalesByDayPrepaids",
									"SalesByDayRefunds",
									"SalesByDayNetSales"
								],
								"supportFields": [
									"DateIndex",
									"StoreName"
								],
								"title": "Sales By Day",
								"width": 4,
								"height": 2,
								"id": "00000"
							},
							null,
							null,
							null
						]
					}
				]
			},
			rowRenderOrder: [rowId],
			cardRenderOrder: []
		}
	}

	biVisitsWorkspace() {
		let rowId = "0000";
		return { 
			id: -3,
			title: "Visits",
			isExport: false,
			details: {
				name: "Visits",
				description: "...",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
					   "rowId":"Row0",
					   "columns":4,
					   "cards":[
						  {
							 "chartType":"card",
							 "initialChartType":"card",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
								   "isAllSelected": true,
								   "label":"Location",
								   "map":"blastbidashMap",
								   "options":[],
								   "selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"TotalClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"Total Client Visits",
							 "width":2,
							 "height":1,
							 "id":"SYQVNKAZKS"
						  },
						  null,
						  {
							 "chartType":"card",
							 "initialChartType":"card",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"NewClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"First Visits",
							 "width":2,
							 "height":1,
							 "id":"SXPBQEJGTC"
						  },
						  null
					   ]
					},
					{
					   "rowId":"Row1",
					   "cards":[
						{
							"chartType":"card",
							"initialChartType":"card",
							"dataSet":"blastbidash",
							"stackedBarDatatype":null,
							"filters":{
							   "storeId":{
								   "isAllSelected": true,
								   "label":"Location",
								   "map":"blastbidashMap",
								   "options":[],
								   "selected":[]
							   }
							},
							"isGroupable":false,
							"groupables":[
							   
							],
							"isGrandTotals":false,
							"isLocked":true,
							"selectedMetrics":[
							   {
								  "metric":"FirstVisitConversionPct",
								  "isYOY":false
							   }
							],
							"supportFields":[
							   
							],
							"title":"First Visit To Autopay Conversions",
							"width":1,
							"height":1,
							"id":"WJTEWDFRZH"
						 },
						  {
							 "chartType":"card",
							 "initialChartType":"card",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"ClassCapacityPct",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"Class Capacity",
							 "width":1,
							 "height":1,
							 "id":"WJXYSARSZH"
						  },
						  {
							"chartType":"card",
							"initialChartType":"card",
							"dataSet":"blastbidash",
							"stackedBarDatatype":null,
							"filters":{
							   "storeId":{
								   "isAllSelected": true,
								   "label":"Location",
								   "map":"blastbidashMap",
								   "options":[],
								   "selected":[]
							   }
							},
							"isGroupable":false,
							"groupables":[
							   
							],
							"isGrandTotals":false,
							"isLocked":true,
							"selectedMetrics":[
							   {
								  "metric":"ApptUtil",
								  "isYOY":false
							   }
							],
							"supportFields":[
							   
							],
							"title":"Appointment Utilization",
							"width":1,
							"height":1,
							"id":"WJTEWDFWRT"
						 }
					   ],
					   "columns":3
					},
					{
					   "rowId":"Row2",
					   "cards":[
						  {
							 "chartType":"bar",
							 "initialChartType":"bar",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"TotalClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"Total Client Visits",
							 "width":4,
							 "height":1,
							 "id":"NLGXPLXIZZ"
						  },
						  null,
						  null,
						  null
					   ],
					   "columns":4
					},
					{
					   "rowId":"Row3",
					   "cards":[
						  {
							 "chartType":"bar",
							 "initialChartType":"bar",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"NewClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"First Visits",
							 "width":4,
							 "height":1,
							 "id":"UALTRSJRBJ"
						  },
						  null,
						  null,
						  null
					   ],
					   "columns":4
					},
					{
						"rowId":"Row4",
						"cards":[
						   {
							  "chartType":"card",
							  "initialChartType":"card",
							  "dataSet":"blastbidash",
							  "stackedBarDatatype":null,
							  "filters":{
								 "storeId":{
									 "isAllSelected": true,
									 "label":"Location",
									 "map":"blastbidashMap",
									 "options":[],
									 "selected":[]
								 }
							  },
							  "isGroupable":false,
							  "groupables":[
								 
							  ],
							  "isGrandTotals":false,
							  "isLocked":true,
							  "selectedMetrics":[
								 {
									"metric":"CompanyAvgMonthlyClientVisits",
									"isYOY":false
								 }
							  ],
							  "supportFields":[
								 
							  ],
							  "title":"Average Monthly Client Visits",
							  "width":2,
							  "height":1,
							  "id":"KSYFUBKAH"
						   },
						   null,
						   {
							  "chartType":"card",
							  "initialChartType":"card",
							  "dataSet":"blastbidash",
							  "stackedBarDatatype":null,
							  "filters":{
								 "storeId":{
									 "isAllSelected": true,
									 "label":"Location",
									 "map":"blastbidashMap",
									 "options":[],
									 "selected":[]
								 }
							  },
							  "isGroupable":false,
							  "groupables":[
								 
							  ],
							  "isGrandTotals":false,
							  "isLocked":true,
							  "selectedMetrics":[
								 {
									"metric":"CompanyAvgMonthlyNewClientVisi",
									"isYOY":false
								 }
							  ],
							  "supportFields":[
								 
							  ],
							  "title":"Average Monthly First Visits",
							  "width":2,
							  "height":1,
							  "id":"UEJDVCJIRC"
						   },
						   null
						],
						"columns":4
					},
					{
					   "rowId":"Row5",
					   "cards":[
						  {
							 "chartType":"table",
							 "initialChartType":"table",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":true,
							 "groupables":[
								"StoreId"
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"LocationAvgMonthlyClientVisits",
								   "isYOY":false
								},
								{
									"metric":"CTAClientVisits",
									"isYOY":false
								}
							 ],
							 "supportFields":[
								"StoreId"
							 ],
							 "title":"Average Monthly Client Visits",
							 "width":2,
							 "height":1,
							 "id":"JYMZVUBKAH"
						  },
						  null,
						  {
							 "chartType":"table",
							 "initialChartType":"table",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":true,
							 "groupables":[
								"StoreId"
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"LocationAvgMonthlyNewClientVis",
								   "isYOY":false
								},
								{
									"metric":"CTANewClientVisits",
									"isYOY":false
								}
							 ],
							 "supportFields":[
								"StoreId"
							 ],
							 "title":"Average Monthly First Visits",
							 "width":2,
							 "height":1,
							 "id":"NFWXVCJIRC"
						  },
						  null
					   ],
					   "columns":4
					}
				 ]
			},
			publishedDetails: {
				name: "Visits",
				description: "...",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
					   "rowId":"Row0",
					   "columns":4,
					   "cards":[
						  {
							 "chartType":"card",
							 "initialChartType":"card",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
								   "isAllSelected": true,
								   "label":"Location",
								   "map":"blastbidashMap",
								   "options":[],
								   "selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"TotalClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"Total Client Visits",
							 "width":2,
							 "height":1,
							 "id":"SYQVNKAZKS"
						  },
						  null,
						  {
							 "chartType":"card",
							 "initialChartType":"card",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"NewClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"First Visits",
							 "width":2,
							 "height":1,
							 "id":"SXPBQEJGTC"
						  },
						  null
					   ]
					},
					{
					   "rowId":"Row1",
					   "cards":[
						{
							"chartType":"card",
							"initialChartType":"card",
							"dataSet":"blastbidash",
							"stackedBarDatatype":null,
							"filters":{
							   "storeId":{
								   "isAllSelected": true,
								   "label":"Location",
								   "map":"blastbidashMap",
								   "options":[],
								   "selected":[]
							   }
							},
							"isGroupable":false,
							"groupables":[
							   
							],
							"isGrandTotals":false,
							"isLocked":true,
							"selectedMetrics":[
							   {
								  "metric":"FirstVisitConversionPct",
								  "isYOY":false
							   }
							],
							"supportFields":[
							   
							],
							"title":"First Visit To Autopay Conversions",
							"width":1,
							"height":1,
							"id":"WJTEWDFRZH"
						 },
						  {
							 "chartType":"card",
							 "initialChartType":"card",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"ClassCapacityPct",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"Class Capacity",
							 "width":1,
							 "height":1,
							 "id":"WJXYSARSZH"
						  },
						  {
							"chartType":"card",
							"initialChartType":"card",
							"dataSet":"blastbidash",
							"stackedBarDatatype":null,
							"filters":{
							   "storeId":{
								   "isAllSelected": true,
								   "label":"Location",
								   "map":"blastbidashMap",
								   "options":[],
								   "selected":[]
							   }
							},
							"isGroupable":false,
							"groupables":[
							   
							],
							"isGrandTotals":false,
							"isLocked":true,
							"selectedMetrics":[
							   {
								  "metric":"ApptUtil",
								  "isYOY":false
							   }
							],
							"supportFields":[
							   
							],
							"title":"Appointment Utilization",
							"width":1,
							"height":1,
							"id":"WJTEWDFWRT"
						 }
					   ],
					   "columns":3
					},
					{
					   "rowId":"Row2",
					   "cards":[
						  {
							 "chartType":"bar",
							 "initialChartType":"bar",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"TotalClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"Total Client Visits",
							 "width":4,
							 "height":1,
							 "id":"NLGXPLXIZZ"
						  },
						  null,
						  null,
						  null
					   ],
					   "columns":4
					},
					{
					   "rowId":"Row3",
					   "cards":[
						  {
							 "chartType":"bar",
							 "initialChartType":"bar",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":false,
							 "groupables":[
								
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"NewClientVisits",
								   "isYOY":false
								}
							 ],
							 "supportFields":[
								
							 ],
							 "title":"First Visits",
							 "width":4,
							 "height":1,
							 "id":"UALTRSJRBJ"
						  },
						  null,
						  null,
						  null
					   ],
					   "columns":4
					},
					{
						"rowId":"Row4",
						"cards":[
						   {
							  "chartType":"card",
							  "initialChartType":"card",
							  "dataSet":"blastbidash",
							  "stackedBarDatatype":null,
							  "filters":{
								 "storeId":{
									 "isAllSelected": true,
									 "label":"Location",
									 "map":"blastbidashMap",
									 "options":[],
									 "selected":[]
								 }
							  },
							  "isGroupable":false,
							  "groupables":[
								 
							  ],
							  "isGrandTotals":false,
							  "isLocked":true,
							  "selectedMetrics":[
								 {
									"metric":"CompanyAvgMonthlyClientVisits",
									"isYOY":false
								 }
							  ],
							  "supportFields":[
								 
							  ],
							  "title":"Average Monthly Client Visits",
							  "width":2,
							  "height":1,
							  "id":"KSYFUBKAH"
						   },
						   null,
						   {
							  "chartType":"card",
							  "initialChartType":"card",
							  "dataSet":"blastbidash",
							  "stackedBarDatatype":null,
							  "filters":{
								 "storeId":{
									 "isAllSelected": true,
									 "label":"Location",
									 "map":"blastbidashMap",
									 "options":[],
									 "selected":[]
								 }
							  },
							  "isGroupable":false,
							  "groupables":[
								 
							  ],
							  "isGrandTotals":false,
							  "isLocked":true,
							  "selectedMetrics":[
								 {
									"metric":"CompanyAvgMonthlyNewClientVisi",
									"isYOY":false
								 }
							  ],
							  "supportFields":[
								 
							  ],
							  "title":"Average Monthly First Visits",
							  "width":2,
							  "height":1,
							  "id":"UEJDVCJIRC"
						   },
						   null
						],
						"columns":4
					},
					{
					   "rowId":"Row5",
					   "cards":[
						  {
							 "chartType":"table",
							 "initialChartType":"table",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":true,
							 "groupables":[
								"StoreId"
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"LocationAvgMonthlyClientVisits",
								   "isYOY":false
								},
								{
									"metric":"CTAClientVisits",
									"isYOY":false
								}
							 ],
							 "supportFields":[
								"StoreId"
							 ],
							 "title":"Average Monthly Client Visits",
							 "width":2,
							 "height":1,
							 "id":"JYMZVUBKAH"
						  },
						  null,
						  {
							 "chartType":"table",
							 "initialChartType":"table",
							 "dataSet":"blastbidash",
							 "stackedBarDatatype":null,
							 "filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options":[],
									"selected":[]
								}
							 },
							 "isGroupable":true,
							 "groupables":[
								"StoreId"
							 ],
							 "isGrandTotals":false,
							 "isLocked":true,
							 "selectedMetrics":[
								{
								   "metric":"LocationAvgMonthlyNewClientVis",
								   "isYOY":false
								},
								{
									"metric":"CTANewClientVisits",
									"isYOY":false
								}
							 ],
							 "supportFields":[
								"StoreId"
							 ],
							 "title":"Average Monthly First Visits",
							 "width":2,
							 "height":1,
							 "id":"NFWXVCJIRC"
						  },
						  null
					   ],
					   "columns":4
					}
				 ]
			},
			rowRenderOrder: [rowId],
			cardRenderOrder: []
		}
	}

	biAutopaysWorkspace() {
		let rowId = "0000";
		return {
			id: -4,
			title: "Autopays",
			isExport: false,
			details: {
				name: "Autopays",
				description: "",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						"rowId":"Row0",
						"columns":4,
						"cards":[
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuccessfulAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Successful Autopays Amount",
								"width":1,
								"height":1,
								"id":"QTRKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuccessfulAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Successful Autopays Count",
								"width":1,
								"height":1,
								"id":"SFTTQXZJSJ"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"DeclinedAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Declined Autopays Amount",
								"width":1,
								"height":1,
								"id":"MSWGROMXFS"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"DeclinedAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Declined Autopays Count",
								"width":1,
								"height":1,
								"id":"PNVWZBFYBJ"
							}
						]
					},
					{
						"rowId":"Row1",
						"columns":4,
						"cards": [
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuspendedAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Suspended Autopays Amount",
								"width":1,
								"height":1,
								"id":"BARKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuspendedAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Suspended Autopays Count",
								"width":1,
								"height":1,
								"id":"BBRKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"TerminatedAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Terminated Autopays Amount",
								"width":1,
								"height":1,
								"id":"BCRKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"TerminatedAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Terminated Autopays Count",
								"width":1,
								"height":1,
								"id":"BDRKVUNQUB"
							}
						]
					},
					{
						"rowId":"Row2",
						"columns":4,
						"cards": [
							{
								"chartType":"bar",
								"initialChartType":"bar",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuccessfulAutopayAmount",
										"isYOY":false
									},
									{
										"metric":"SuccessfulAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Autopay Sales",
								"width":4,
								"height":1,
								"id":"CARKVUNQUB"
							},
							null,
							null,
							null
						]
					},
					{
						"rowId":"Row3",
						"columns":4,
						"cards": [
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"CompanyAvgMonthlyAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Average Monthly Autopays Count",
								"width":2,
								"height":1,
								"id":"DARKVUNQUB"
							},
							null,
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"CompanyAvgMonthlySuccessfulAut",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Average Monthly Autopays Amount",
								"width":2,
								"height":1,
								"id":"DCRKVUNQUB"
							},
							null
						]
					},
					{
						"rowId":"Row4",
						"columns":4,
						"cards": [
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":[
									"StoreId"
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"LocAvgMonthlySuccessfulAutoCnt",
										"isYOY":false
									},
									{
										"metric":"CTASuccessfulAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									"StoreId"
								],
								"title":"AAverage Monthly Autopays Count",
								"width":2,
								"height":1,
								"id":"EAMZVUBKAH"
							},
							null,
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":[
									"StoreId"
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"LocAvgMonthlySuccessfulAutopay",
										"isYOY":false
									},
									{
										"metric":"CTASuccessfulAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									"StoreId"
								],
								"title":"AAverage Monthly Autopays Amount",
								"width":2,
								"height":1,
								"id":"EAMZVUBKAH"
							},
							null
						]
					}
				]
			},
			publishedDetails: {
				name: "Autopays",
				description: "",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						"rowId":"Row0",
						"columns":4,
						"cards":[
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuccessfulAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Successful Autopays Amount",
								"width":1,
								"height":1,
								"id":"QTRKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuccessfulAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Successful Autopays Count",
								"width":1,
								"height":1,
								"id":"SFTTQXZJSJ"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"DeclinedAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Declined Autopays Amount",
								"width":1,
								"height":1,
								"id":"MSWGROMXFS"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"DeclinedAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Declined Autopays Count",
								"width":1,
								"height":1,
								"id":"PNVWZBFYBJ"
							}
						]
					},
					{
						"rowId":"Row1",
						"columns":4,
						"cards": [
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuspendedAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Suspended Autopays Amount",
								"width":1,
								"height":1,
								"id":"BARKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuspendedAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Suspended Autopays Count",
								"width":1,
								"height":1,
								"id":"BBRKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"TerminatedAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Terminated Autopays Amount",
								"width":1,
								"height":1,
								"id":"BCRKVUNQUB"
							},
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"TerminatedAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Terminated Autopays Count",
								"width":1,
								"height":1,
								"id":"BDRKVUNQUB"
							}
						]
					},
					{
						"rowId":"Row2",
						"columns":4,
						"cards": [
							{
								"chartType":"bar",
								"initialChartType":"bar",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"SuccessfulAutopayAmount",
										"isYOY":false
									},
									{
										"metric":"SuccessfulAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Autopay Sales",
								"width":4,
								"height":1,
								"id":"CARKVUNQUB"
							},
							null,
							null,
							null
						]
					},
					{
						"rowId":"Row3",
						"columns":4,
						"cards": [
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"CompanyAvgMonthlyAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Average Monthly Autopays Count",
								"width":2,
								"height":1,
								"id":"DARKVUNQUB"
							},
							null,
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[
									
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"CompanyAvgMonthlySuccessfulAut",
										"isYOY":false
									}
								],
								"supportFields":[
									
								],
								"title":"Average Monthly Autopays Amount",
								"width":2,
								"height":1,
								"id":"DCRKVUNQUB"
							},
							null
						]
					},
					{
						"rowId":"Row4",
						"columns":4,
						"cards": [
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":[
									"StoreId"
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"LocAvgMonthlySuccessfulAutoCnt",
										"isYOY":false
									},
									{
										"metric":"CTASuccessfulAutopayCount",
										"isYOY":false
									}
								],
								"supportFields":[
									"StoreId"
								],
								"title":"Average Monthly Autopays Count",
								"width":2,
								"height":1,
								"id":"EAMZVUBKAH"
							},
							null,
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options":[],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":[
									"StoreId"
								],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"LocAvgMonthlySuccessfulAutopay",
										"isYOY":false
									},
									{
										"metric":"CTASuccessfulAutopayAmount",
										"isYOY":false
									}
								],
								"supportFields":[
									"StoreId"
								],
								"title":"Average Monthly Autopays Amount",
								"width":2,
								"height":1,
								"id":"ECMZVUBKAH"
							},
							null
						]
					}
				]
			},
			rowRenderOrder: [rowId],
			cardRenderOrder: []
		}
	}

	biSalesWorkspace() {
		let rowId = "0000";
		return {
			id: -2,
			title: "Sales",
			isExport: false,
			details: {
				name: "Sales",
				description: "...",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						"rowId":"JTISVPDXDQ",
						"columns":4,
						"cards":[
						{
							"chartType":"card",
							"initialChartType":"card",
							"dataSet":"blastbidash",
							"stackedBarDatatype":null,
							"filters": {
								"storeId": {
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options": [],
									"selected":[]
								}
							},
							"isGroupable":false,
							"groupables":[],
							"isGrandTotals":false,
							"isLocked":true,
							"selectedMetrics": [{
								"metric":"TotalSales",
								"isYOY":false
							}],
							"supportFields":[],
							"title":"Total Sales",
							"width":2,"height":1,
							"id":"BOXUSDWKJU"
						},
						null,
						{
							"chartType":"table",
							"initialChartType":"table",
							"dataSet":"blastbidash",
							"stackedBarDatatype":null,
							"filters":{
								"storeId":{
									"isAllSelected": true,
									"label":"Location",
									"map":"blastbidashMap",
									"options": [],
									"selected":[]
								}
							},
							"isGroupable":true,
							"groupables":["StoreId"],
							"isGrandTotals":false,
							"isLocked":true,
							"selectedMetrics":[
								{
									"metric":"TotalSales",
									"isYOY":false
								},
								{
									"metric":"TotalSales",
									"isYOY":true
								}
							],
							"supportFields":["StoreId"],
							"title":"Sales Growth YOY",
							"width":2,
							"height":1,
							"id":"ZYEEQVQXVU"
						},
						null
						]
					},
					{
						"rowId":"DRUSHHQPNF",
						"cards":[
							{
								"chartType":"pie",
								"initialChartType":"pie",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"TotalSales",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Sales By Location",
								"width":4,
								"height":2,
								"id":"TDXZYHCYPZ"
							},
							null,
							null,
							null
						],
						"columns":4
					},
					{
						"rowId":"VXGERNBZVS",
						"cards":[null,null,null,null],
						"columns":4
					},
					{
						"rowId":"LZALNLFBRL",
						"cards":[
							{
								"chartType":"bar",
								"initialChartType":"bar",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"ProductSales",
										"isYOY":false
									},
									{
										"metric":"ServiceSales",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Total Sales",
								"width":4,
								"height":1,
								"id":"PGPWDBGJEG"
							},
							null,
							null,
							null
						],
						"columns":4
					},
					{
						"rowId":"URPOBIYSZP",
						"cards":[
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"AverageClientSpend",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Average Client Spend",
								"width":2,
								"height":1,
								"id":"UQJMXCEIFE"
							},
							null,
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"AverageClientSpend",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Average Network Sales",
								"width":2,
								"height":1,
								"id":"UROJVVZEOL"
							},
							null
						],
						"columns":4
					},
					{
						"rowId":"VRPOBIYSZP",
						"cards":[
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":["StoreId"],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"AverageClientSpend",
										"isYOY":false
									}
								],
								"supportFields":["StoreId"],
								"title":"Average Client Spend",
								"width":2,
								"height":1,
								"id":"LQJMXCEIFE"
							},
							null,
							{
								"chartType":"card",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"AverageClientSpend",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Average Network Sales",
								"width":2,
								"height":1,
								"id":"SROJVVZEOL"
							},
							null
						],
						"columns":4
					}
				]
			},
			publishedDetails: {
				name: "Sales",
				description: "...",
				lastSaved: moment().format("MM/DD/YYYY h:mm a z"),
				rows: [
					{
						"rowId":"JTISVPDXDQ",
						"columns":4,
						"cards":[
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters": {
									"storeId": {
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics": [
									{
										"metric":"TotalSales",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Total Sales",
								"width":2,"height":1,
								"id":"BOXUSDWKJU"
							},
							null,
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":["StoreId"],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"TotalSales",
										"isYOY":false
									},
									{
										"metric":"TotalSales",
										"isYOY":true
									}
								],
								"supportFields":["StoreId"],
								"title":"Sales Growth YOY",
								"width":2,
								"height":1,
								"id":"ZYEEQVQXVU"
							},
							null
						]
					},
					{
						"rowId":"DRUSHHQPNF",
						"cards":[
							{
								"chartType":"pie",
								"initialChartType":"pie",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"TotalSales",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Sales By Location",
								"width":4,
								"height":2,
								"id":"TDXZYHCYPZ"
							},
							null,
							null,
							null
						],
						"columns":4
					},
					{
						"rowId":"VXGERNBZVS",
						"cards":[null,null,null,null],
						"columns":4
					},
					{
						"rowId":"LZALNLFBRL",
						"cards":[
							{
								"chartType":"bar",
								"initialChartType":"bar",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"ProductSales",
										"isYOY":false
									},
									{
										"metric":"ServiceSales",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Total Sales",
								"width":4,
								"height":1,
								"id":"PGPWDBGJEG"
							},
							null,
							null,
							null
						],
						"columns":4
					},
					{
						"rowId":"URPOBIYSZP",
						"cards":[
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"CompanyAvgClientSpend",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Average Client Spend",
								"width":2,
								"height":1,
								"id":"UQJMXCEIFE"
							},
							null,
							{
								"chartType":"card",
								"initialChartType":"card",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":false,
								"groupables":[],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"CompanyAvgMonthlySales",
										"isYOY":false
									}
								],
								"supportFields":[],
								"title":"Average Network Sales",
								"width":2,
								"height":1,
								"id":"UROJVVZEOL"
							},
							null
						],
						"columns":4
					},
					{
						"rowId":"VRPOBIYSZP",
						"cards":[
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":["StoreId"],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"LocAvgMonthlyClientSpend",
										"isYOY":false
									},
									{
										"metric":"CTAClientSpend",
										"isYOY":false
									}
								],
								"supportFields":["StoreId"],
								"title":"Average Client Spend",
								"width":2,
								"height":1,
								"id":"LQJMXCEIFE"
							},
							null,
							{
								"chartType":"table",
								"initialChartType":"table",
								"dataSet":"blastbidash",
								"stackedBarDatatype":null,
								"filters":{
									"storeId":{
										"isAllSelected": true,
										"label":"Location",
										"map":"blastbidashMap",
										"options": [],
										"selected":[]
									}
								},
								"isGroupable":true,
								"groupables":["StoreId"],
								"isGrandTotals":false,
								"isLocked":true,
								"selectedMetrics":[
									{
										"metric":"LocAvgMonthlySalesNoTax",
										"isYOY":false
									},
									{
										"metric":"CTATotalSalesNoTax",
										"isYOY":false
									}
								],
								"supportFields":["StoreId"],
								"title":"Average Network Sales",
								"width":2,
								"height":1,
								"id":"SROJVVZEOL"
							},
							null
						],
						"columns":4
					}
				]
			},
			rowRenderOrder: [rowId],
			cardRenderOrder: []
		}
	}

	modifyWorkspace(field, value, callback) {
		let workspaces = this.state.workspaces;
		workspaces.forEach(ws => {
			if (ws.id === this.state.activeWorkspaceId) {
				ws.details[field] = value
				ws.details.lastSaved = moment().format("MM/DD/YYYY h:mm a z")
				this.saveWorkspace(ws);
			}
		})
		this.setState({ workspaces: workspaces }, callback)
	}

	modifyWorkspaceNoSave(field, value, callback) {
		let workspaces = this.state.workspaces;
		workspaces.forEach(ws => {
			if (ws.id === this.state.activeWorkspaceId) {
				ws.details[field] = value;
			}
		})
		this.setState({ workspaces: workspaces });
	}

	clearAllVisuals(workspaceId) {
		let workspaces = this.state.workspaces;

		workspaces.forEach(ws => {
			if (ws.id === workspaceId) {
				ws.details.rows.forEach(row => {
					row.cards = []
				});
				ws.details.lastSaved = moment().format("MM/DD/YYYY h:mm a z");
				this.saveWorkspace(ws);
			}
		})

		this.setState({ workspaces: workspaces });
	}

	createVisual(newCardForm) {

		newCardForm.width = 1;
		newCardForm.height = 1;

		newCardForm.id = this.createRowId();

		let workspaces = this.state.workspaces;
		let coords = this.state.newCardCoordinates;

		let tmpWs = null;
		workspaces.forEach(workspace => {
			if (workspace.id === this.state.activeWorkspaceId) {
				tmpWs = workspace;
				workspace.cardRenderOrder.push(newCardForm.id);
				let cards = workspace.details.rows[coords.y].cards;
				let columns = workspace.details.rows[coords.y].columns;

				if (cards.length === 0) {
					for (var i = 0; i < columns; i++) {
						cards.push(null);
					}
				}

				cards[coords.x] = newCardForm;
			}
		})

		if (tmpWs != null) {

			this.saveWorkspace(tmpWs, () => {
				this.setState({ workspaces: workspaces }, () => {
					this.closeModal(false);

					if (newCardForm.chartType != "line") {

						if (this.lastKpiColumns === undefined || !this.lastKpiColumns[newCardForm.dataSet.toUpperCase()]) {
							this.setState({cardLoading: newCardForm.id});
							this.pullDataByCards();
						} else {

							let shouldLoadData = false;
							newCardForm.selectedMetrics.forEach(obj => {
								if (!shouldLoadData && !this.lastKpiColumns[newCardForm.dataSet.toUpperCase()].includes(obj.metric)) {
									shouldLoadData = true;
								}
							})
							if (shouldLoadData) {
								this.setState({cardLoading: newCardForm.id});
								this.pullDataByCards();
							}
						}

					} else {

						if (this.lastLongKpiColumns === undefined || !this.lastLongKpiColumns[newCardForm.dataSet.toUpperCase()]) {
							this.setState({cardLoading: newCardForm.id});
							this.pullLongDataByCards();
						} else {

							let shouldLoadData = false;
							newCardForm.selectedMetrics.forEach(obj => {
								if (!shouldLoadData && !this.lastLongKpiColumns[newCardForm.dataSet.toUpperCase()].includes(obj.metric)) {
									shouldLoadData = true;
								}
							})
							if (shouldLoadData) {
								this.setState({cardLoading: newCardForm.id});
								this.pullLongDataByCards();
							}
						}
					}
				})
			});
		}
	}

	saveEditVisual(cardForm) {
		let workspaces = this.state.workspaces;
		let tmpWs = null;

		workspaces.forEach(workspace => {
			if (workspace.id === this.state.activeWorkspaceId) {
				tmpWs = workspace;
				workspace.details.rows.forEach(row => {
					row.cards.forEach(card => {
						if (card != null && card.id === cardForm.id) {
							card.title = cardForm.title;
							card.chartType = cardForm.chartType;
							card.dataSet = cardForm.dataSet;
							card.selectedMetrics = cardForm.selectedMetrics;
							card.groupables = cardForm.groupables;
							card.supportFields = cardForm.supportFields;
							card.isGroupable = cardForm.isGroupable;
							card.isGrandTotals = cardForm.isGrandTotals;
							card.isLocked = cardForm.isLocked;
							card.filters = cardForm.filters;
						}
					})
				})
			}
		})

		if (tmpWs != null) {

			this.saveWorkspace(tmpWs, () => {
				this.setState({ workspaces: workspaces }, () => {
					this.closeModal(false);

					if (cardForm.chartType != "line") {

						if (this.lastKpiColumns === undefined || !this.lastKpiColumns[cardForm.dataSet.toUpperCase()]) {
							this.setState({cardLoading: cardForm.id});
							this.pullDataByCards();
						} else {

							let shouldLoadData = false;
							cardForm.selectedMetrics.forEach(obj => {
								if (!shouldLoadData && !this.lastKpiColumns[cardForm.dataSet.toUpperCase()].includes(obj.metric)) {
									shouldLoadData = true;
								}
							})
							if (shouldLoadData) {
								this.setState({cardLoading: cardForm.id});
								this.pullDataByCards();
							}
						}

					} else {

						if (this.lastLongKpiColumns === undefined || !this.lastLongKpiColumns[cardForm.dataSet.toUpperCase()]) {
							this.setState({cardLoading: cardForm.id});
							this.pullLongDataByCards();
						} else {

							let shouldLoadData = false;
							cardForm.selectedMetrics.forEach(obj => {
								if (!shouldLoadData && !this.lastLongKpiColumns[cardForm.dataSet.toUpperCase()].includes(obj.metric)) {
									shouldLoadData = true;
								}
							})
							if (shouldLoadData) {
								this.setState({cardLoading: cardForm.id});
								this.pullLongDataByCards();
							}
						}
					}
				})
			});
		}
	}

	toggleLock(card) {
		this.saveEditVisual(card);
		this.publishWorkspace();
	}

	toggleChart(card) {
		let workspaces = this.state.workspaces;
		let tmpWs = null;
		workspaces.forEach(workspace => {
			if (workspace.id === this.state.activeWorkspaceId) {
				tmpWs = workspace;
				workspace.publishedDetails.rows.forEach(row => {
					row.cards.forEach(cardForm => {
						if (cardForm !== null && cardForm.id === card.id) {
							cardForm.chartType = card.chartType;
							if (cardForm.initialChartType === undefined) {
								cardForm.initialChartType = card.initialChartType;
							}
						}
					})
				})
				workspace.details.rows.forEach(row => {
					row.cards.forEach(cardForm => {
						if (cardForm !== null && cardForm.id === card.id) {
							cardForm.chartType = card.chartType;
							if (cardForm.initialChartType === undefined) {
								cardForm.initialChartType = card.initialChartType;
							}
						}
					})
				})
			}
		})
		if (tmpWs !== null) {
			this.saveWorkspace(tmpWs, () => {
				this.setState({ workspaces: workspaces })
			})
		}
	}

	deleteVisual(id) {
		let workspaces = this.state.workspaces;

		workspaces.forEach(workspace => {
			workspace.details.rows.forEach(row => {
				for (var i = 0; i < row.cards.length; i++) {
					if (row.cards[i] != null && row.cards[i].id === id) {
						row.cards[i] = null;

						this.saveWorkspace(workspace);
						break;
					}
				}
			})
		})

		this.setState({ workspaces: workspaces, visualizationOpenMenuId: null })
	}

	openVisualizationMenu(id) {
		this.setState({ visualizationOpenMenuId: id })
	}

	closeVisualizationMenu() {
		this.setState({ visualizationOpenMenuId: null })
	}

	selectCard(card) {
		let newCard = null;

		let metricFilter = this.state.metricFilter;
		let locationFilter = this.state.locationFilter;

		if (this.state.activeCard != card) {
			newCard = card;

			if (!newCard.selectedMetricsIsDynamic) {
				metricFilter.selectedMetrics = newCard.selectedMetrics;
			}
			if (!newCard.selectedLocationsIsDynamic) {
				locationFilter.selectedLocations = newCard.selectedLocations;
			}
		}

		this.setState({ activeCard: newCard, locationFilter: locationFilter, metricFilter: metricFilter })
	}

	editCard(property, value) {
		let card = this.state.activeCard;

		if (card != null) {
			card[property] = value;
		}

		this.setState({ activeCard: card })
	}

	openModal(modalType) {
		this.setState({ modalOpen: true, modalType: modalType, editCardIdentity: null })
	}

	metricDefinitions(modalType, card) {
		this.setState({ modalOpen: true, modalType: modalType, editCardIdentity: null, cardType: card.dataSet })
	}

	openNewCardModal(row, column) {
		let newCardCoordinates = { x: column, y: row }
		this.setState({ modalOpen: true, modalType: "new-card", newCardCoordinates: newCardCoordinates, editCardIdentity: null })
	}

	openEditCardModal(cardIdentity) {
		console.log('opening card for edit ' + cardIdentity.id)
		this.setState({ modalOpen: true, modalType: "edit-card", editCardIdentity: cardIdentity });
	}

	closeModal(showConfirm) {
		showConfirm = typeof showConfirm === "boolean" ? showConfirm : false;
		let tmpCloseFunc = () => {
			this.setState({ modalOpen: false }, () => {
				setTimeout(() => {
					this.setState({ modalType: null, editCardIdentity: null });
				}, 350)
			})
		}
		if (this.state.modalType === "new-card" && showConfirm) {
			zconfirm("Are you sure you want to stop creating a new visual?", tmpCloseFunc)
		} else {
			tmpCloseFunc();
		}
	}

	openFullscreen(card) {
		console.log(card);

		this.setState({ leftBarOpen: false, fullscreenId: card.id, visualizationOpenMenuId: null })
	}

	closeFullscreen() {
		this.setState({ leftBarOpen: false, fullscreenId: null, visualizationOpenMenuId: null })
	}

	openVisualFilter(card) {
		console.log(card);

		this.setState({ leftBarOpen: true, fullscreenId: card.id, visualizationOpenMenuId: null })
	}

	closeVisualFilter() {
		this.setState({ leftBarOpen: false, fullscreenId: null, visualizationOpenMenuId: null })
	}

	dateIndexToDate(dateIndex) {
		return moment(dateIndex + "", "YYYYMMDD").format("MM/DD/YYYY");
	}

	dateToDateIndex(dateString) {
		return parseInt(moment(dateString, "MM/DD/YYYY").format("YYYYMMDD"));
	}

	dateIndexRange(fromDateIndex, toDateIndex) {
		if (fromDateIndex > toDateIndex) {
			let tmp = fromDateIndex;
			fromDateIndex = toDateIndex;
			toDateIndex = tmp;
		}

		let currentDateIndex = fromDateIndex;
		let result = [];
		while (currentDateIndex <= toDateIndex) {
			result.push(currentDateIndex);
			currentDateIndex = parseInt(moment(currentDateIndex + "", "YYYYMMDD").add(1, 'days').format("YYYYMMDD"))
		}
		return result;
	}

	commaFormat(num) {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	createRowId() {
		let options = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
		let id = ""
		for (var i = 0; i < 10; i++) {
			id += options[Math.floor(Math.random() * options.length)]
		}
		return id
	}

	toCammelCase(str) {
		return str.substring(0, 1).toLowerCase() + str.substring(1);
	}

	toFriendlyName(dataSet, dataColumn, value) {
		dataColumn = this.toCammelCase(dataColumn);
		let dFilters = this.state.defaultFilters;
		let maps = this.state.allMaps;
		if (dFilters && dFilters[dataSet] && dFilters[dataSet][dataColumn] &&
			dFilters[dataSet][dataColumn].map && maps[dFilters[dataSet][dataColumn].map] &&
			maps[dFilters[dataSet][dataColumn].map][value]) {
			return maps[dFilters[dataSet][dataColumn].map][value]
		} //Temporary untill we return product data in the dfilter.
		else if (dataColumn == "productId") {
			return maps.productMap[value];
		} //Temporary untill we return district data in the dfilter.
		else if (dataColumn == "districtId") {
			return maps.districtMap[value];
		}
		else {
			return value;
		}
	}

	generateFriendlyName(fieldName, isKpi) {
		let friendlyName = "";

		if (!isKpi) {
			if(fieldName === 'onlineStoreId') {
				friendlyName = 'Online Store';
			} else {
				friendlyName = this.state.allMaps.columnHeaderMap[fieldName];
			}
		} else {
			let gcField
			if (fieldName === 'PPC' || fieldName === 'PPG') {
				gcField = fieldName.toLowerCase();
			} else if (fieldName.slice(0, 3) === 'CTA') {
				gcField = fieldName.slice(0, 3).toLowerCase() + fieldName.slice(3) || '';
			} else {
				gcField = fieldName.slice(0, 2).toLowerCase() + fieldName.slice(2) || '';
			}
			friendlyName = this.state.allMaps.kpiNamingMap[toCammelCase(fieldName)] || this.state.allMaps.kpiNamingMap[toCammelCase(gcField)];
		}
		return friendlyName;
	}

	generateNameFromID(id, type) {
		let name = "";

		switch (type.toUpperCase()) {
			case "BLAST":
				name = this.state.allMaps.storeMap[id];
				break;
			case "BLASTPROD":
				name = this.state.allMaps.productMap[id];
				break;
			case "BLASTTREAT":
				name = this.state.allMaps.treatmentMap[id];
				break;
			case "BRAND":
				name = this.state.allMaps.brandMap[id];
				break;
		}
		return name;

		// this.state.allMaps[this.state.defaultFilters[dataSet][dataColumn].map][value]; //do ternary check to see if any of the 3 params are undefined or null
	}

	exportData(exportType, workspace, cardId) {

		//[{name:"Unknown Sheet",data:[]}
		let cardIds = [];
		var dataWrapper = { name: workspace.publishedDetails.name, dataSets: [] };

		var counter = 0;//needed for csv single card export name
		var firstCardName = "";

		if (exportType == "csv" || exportType == "excel") {

			workspace.publishedDetails.rows.forEach(row => {
				row.cards.forEach(identity => {
					if (identity != null) {
						if ((cardId == null) || (identity != null && identity.id == cardId)) {

							if (counter === 0) {
								firstCardName = identity.title;
							}

							var dataSetObj = { dsName: identity.dataSet, name: identity.title, data: [] };
							var rawAllData = WorkspaceDataManager.groupData(WorkspaceDataManager.filterData(this.state.allData[identity.dataSet], identity, this.state.workspaceFilters, this.state.defaultFilters), identity, this.state.defaultGroupings, this.state.allMaps, this.state.metricDefinitions, this.state.allData[identity.dataSet], this.state.timeFilter);
							var rawRangeData = WorkspaceDataManager.groupData(WorkspaceDataManager.filterData(this.state.longData[identity.dataSet], identity, this.state.workspaceFilters, this.state.defaultFilters), identity, this.state.defaultGroupings, this.state.allMaps, this.state.metricDefinitions, this.state.allData[identity.dataSet], this.state.timeFilter);

							if (rawAllData != undefined && rawAllData != null && rawAllData.length > 0) {
								let orderedRawData = [];
								identity.selectedMetrics.forEach(metric => {
									rawAllData.forEach(d => {
										if(metric.metric === d.kpiIdentifier) {
											orderedRawData.push(d);
										}
									})
								})
								dataSetObj.data = orderedRawData;
							}
							else if (rawRangeData != undefined && rawRangeData != null && rawRangeData.length > 0) {
								let orderedRangeData = [];
								identity.selectedMetrics.forEach(metric => {
									rawAllData.forEach(d => {
										if(metric.metric === d.kpiIdentifier) {
											orderedRangeData.push(d);
										}
									})
								})
								dataSetObj.data = orderedRangeData;
							}

							dataWrapper.dataSets.push(dataSetObj);

							let showGrandTotal = false;
							if (identity.isGrandTotals !== undefined && identity.isGrandTotals !== null) {
								showGrandTotal = identity.isGrandTotals;
							}

							dataWrapper.ShowGrandTotal = showGrandTotal;

							cardIds.push(identity.id);
							counter++;
						} else {
							console.log(`identity was either null or identity.id != cardid, Identity.Id:${identity.id}, cardid: ${cardId}`);
						}
					}
				});

			});
			if (counter === 1) {
				dataWrapper.name = workspace.publishedDetails.name + " (" + firstCardName + ")";
			}
		}
		else if (exportType == "pdf") {
			dataWrapper.cardIds = cardIds;
			if (cardId == null) {
				dataWrapper.dataSets.push({ data: document.getCenterHTML() });
			}
			else {
				var htmlData = "<div style='margin-right:35px'>" + document.getSingleCardHTML(cardId) + "</div>"
				dataWrapper.dataSets.push({ data: htmlData });
			}
		}
		console.log(this.state.timeFilter);
		window.dataWrapper = dataWrapper;
		this.exportManager.formatAndSend(exportType, dataWrapper, this.state.allMaps, this.state.timeFilter);
		this.state.visualizationOpenMenuId = null;
	}

	exportPdf(card) {

		this.props.loadingOn(() => {

			try {

				//let el = document.getElementById("workspace-center-scroll-fill");
				let el = document.getElementById("workspace-center-outer");

				if (card != null) {
					el = document.getElementById("visualization-card-id-" + card.id);
				}

				let fromDate = moment(this.state.timeFilter.fromDate + "", "YYYYMMDD").format("MM-DD-YYYY");
				let toDate = moment(this.state.timeFilter.toDate + "", "YYYYMMDD").format("MM-DD-YYYY");
				let documentName = "Insights Dashboard" + " -- " + fromDate + " to " + toDate + ".pdf" ;
	
				html2canvas(el, { scale:2 }).then(canvas => {
                    var imgData = canvas.toDataURL("image/jpeg", 1.0);
					var pdf = new jsPDF({
						orientation: "landscape",
						format: "A2",
						unit: "px",
					});

					const pageWidth = pdf.internal.pageSize.getWidth();
					const pageHeight = pdf.internal.pageSize.getHeight();

					const widthRatio = pageWidth / canvas.width;
					const heightRatio = pageHeight / canvas.height;
					const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

					const canvasWidth = canvas.width * ratio;
					const canvasHeight = canvas.height * ratio;

					const marginX = (pageWidth - canvasWidth) / 2;
					const marginY = (pageHeight - canvasHeight) / 2;
					
					pdf.addImage(imgData, 'PNG', marginX, marginY, canvasWidth, canvasHeight);
					pdf.save(documentName);

				});
				
				setTimeout(() => this.props.loadingOff(), 1000);
			} catch (ex) {
			}
		})
	}

	toggleShareOptions(shareEntity) {
		if (this.state.shareWithEntity === shareEntity) {
			this.setState({
				shareWithEntity: "none"
			});
		} else {
			this.setState({
				shareWithEntity: shareEntity
			});
		}
	}

	selectRoleOption(roleUserTypeId) {
		let tmpWorkspaceUserRoles = this.state.workspaceUserRoles;

		tmpWorkspaceUserRoles.reduce((r, e) => {
			if (e.userTypeId === roleUserTypeId) {
				e.isShared = !e.isShared;
				e.canEdit = e.isShared;
				r.push(e);
			} else {
				r.push(e);
			}

			return r;
		}, [])

		this.setState({
			workspaceUserRoles: tmpWorkspaceUserRoles
		});
	}

	selectUserOption(userId) {
		let tmpWorkspaceUsers = this.state.workspaceUsers;

		tmpWorkspaceUsers.reduce((r, e) => {
			if (e.userId === userId) {
				e.isShared = !e.isShared;
				e.canEdit = e.isShared;
				r.push(e);
			} else {
				r.push(e);
			}
			return r;
		}, []);

		this.setState({
			workspaceUsers: tmpWorkspaceUsers
		});
	}

	selectRoleEditOption(roleUserTypeId) {
		let tmpWorkspaceUserRoles = this.state.workspaceUserRoles;

		tmpWorkspaceUserRoles.reduce((r, e) => {
			if (e.userTypeId === roleUserTypeId && e.isShared === true) {
				e.canEdit = !e.canEdit;
				r.push(e);
			} else {
				r.push(e);
			}
			return r;
		}, []);

		this.setState({
			workspaceUserRoles: tmpWorkspaceUserRoles
		});
	}

	selectUserEditOption(userId) {
		let tmpWorkspaceUsers = this.state.workspaceUsers;

		tmpWorkspaceUsers.reduce((r, e) => {
			if (e.userId === userId) {
				e.canEdit = !e.canEdit;
				r.push(e);
			} else {
				r.push(e);
			}
			return r;
		}, []);

		this.setState({
			workspaceUsers: tmpWorkspaceUsers
		});
	}

	generateShareRoleOptionsJsx() {
		let shareRolesJsx = [];

		this.state.workspaceUserRoles.forEach(role => {
			let pencilColor = role.canEdit === true && role.isShared === true ? " active" : role.isShared === true && role.canEdit === false ? " shared-but-edit-disabled" : "";

			shareRolesJsx.push(
				<div className={"role-option" + (role.isShared === true ? " selected" : "")}>
					<div className={"checkbox"}>
						<div className={"material-icons check"} onClick={() => this.selectRoleOption(role.userTypeId)}>{"check"}</div>
					</div>
					<div className={"role-option-label"} onClick={() => this.selectRoleOption(role.userTypeId)}>{role.userTypeName}</div>
					<div className={"role-option-edit"}>
						<div className={"material-icons pencil" + pencilColor} onClick={() => this.selectRoleEditOption(role.userTypeId)}>{"edit"}</div>
					</div>
				</div>
			);
		});
		return shareRolesJsx;
	}

	generateShareUserOptionsJsx() {
		let shareUsersJsx = [];

		this.state.workspaceUsers.sort((a, b) => {
			let fa = a.firstName.toLowerCase(),
				fb = b.firstName.toLowerCase();

			if (fa < fb) {
				return -1;
			}
			if (fa > fb) {
				return 1;
			}
			return 0;
		});

		this.state.workspaceUsers.forEach(user => {
			if(zzDataCache.account.userType > 0) {
				if(user.userTypeId > 0) {
					let pencilColor = user.canEdit === true && user.isShared === true ? " active" : user.isShared === true && user.canEdit === false ? " shared-but-edit-disabled" : "";
	
					shareUsersJsx.push(
						<div className={"user-option" + (user.isShared === true ? " selected" : "")}>
							<div className={"checkbox"}>
								<div className={"material-icons check"} onClick={() => this.selectUserOption(user.userId)}>{"check"}</div>
							</div>
							<div className={"user-option-label"} onClick={() => this.selectUserOption(user.userId)}>{user.firstName + " " + user.lastName}</div>
							<div className={"user-option-edit"}>
								<div className={"material-icons pencil" + pencilColor} onClick={() => this.selectUserEditOption(user.userId)}>{"edit"}</div>
							</div>
						</div>
					);
				}
			} else {
				let pencilColor = user.canEdit === true && user.isShared === true ? " active" : user.isShared === true && user.canEdit === false ? " shared-but-edit-disabled" : "";

				shareUsersJsx.push(
					<div className={"user-option" + (user.isShared === true ? " selected" : "")}>
						<div className={"checkbox"}>
							<div className={"material-icons check"} onClick={() => this.selectUserOption(user.userId)}>{"check"}</div>
						</div>
						<div className={"user-option-label"} onClick={() => this.selectUserOption(user.userId)}>{user.firstName + " " + user.lastName}</div>
						<div className={"user-option-edit"}>
							<div className={"material-icons pencil" + pencilColor} onClick={() => this.selectUserEditOption(user.userId)}>{"edit"}</div>
						</div>
					</div>
				);
			}
		});
		return shareUsersJsx;
	}

	generateDefaultCheckBoxAreaJsx() {
		if (zzDataCache.account.userType !== 0) {
			return null;
		}
		let jsx = (<div className={"default-check-area" + (this.state.workspaceDefault === true ? " selected" : "")}>
			<div className={"default-checkbox"}>
				<div className={"material-icons check"} onClick={() => this.toggleDefault()}>{"check"}</div>
			</div>
			<div className={"default-check-label"} onClick={() => this.toggleDefault()}>{"Default"}</div>
		</div>)
		return jsx;
	}

	submitShareData() {

		let workspaceShareData = {
			workspaceId: this.state.activeWorkspaceId,
			workspaceUsers: this.state.workspaceUsers,
			workspaceUserRoles: this.state.workspaceUserRoles,
			workspaceDefault: this.state.workspaceDefault
		};

		this.workspaceService.saveWorkspaceShareData(workspaceShareData, res => {

			// if (openWorkspaces.includes(workspaceId)) {
			// 	openWorkspaces.splice(openWorkspaces.indexOf(workspaceId), 1);
			// 	this.saveOpenWorkspacesLocal(openWorkspaces)
			// }

			// for (var i = 0; i < workspaces.length; i++) {
			// 	if (workspaces[i].id === workspaceId) {
			// 		workspaces.splice(i, 1);
			// 		break;
			// 	}
			// }

			// this.setState({
			// 	workspaces: workspaces,
			// 	activeWorkspaceId: null,
			// 	isDesignMode: false,
			// 	openWorkspaces: openWorkspaces
			// })
			console.log(res);

		}, err => {
			console.log(err);
		});

		this.closeModal(false);
	}

	toggleDefault() {
		this.setState({
			workspaceDefault: !this.state.workspaceDefault
		});
	}

	generateModalJsx() {
		switch (this.state.modalType) {
			case "open-workspaces":
				let openWorkspaceOptions = this.state.workspaces.reduce((r, e) => {

					r.push((
						<div
							className={"option-outer" + (this.state.openWorkspaces.includes(e.id) ? " selected" : "")}
							onClick={this.toggleWorkspaceOpen.bind(null, e)}
						>
							<div className={"checkbox"}>
								<div className={"material-icons check"}>{"check"}</div>
							</div>
							<div className={"option-label"} title={e.publishedDetails.name}>{e.publishedDetails.name}</div>
						</div>
					))


					return r;
				}, []);

				return (
					<div className={"open-workspace-modal-container"}>
						<div className={"header"}>{"Open dashboards"}<div className={"workspace-model-X"} onClick={() => this.closeModal(false)}><div class="material-icons back-button">close</div></div></div>
						<div className={"open-workspace-modal"}>
							{openWorkspaceOptions}
						</div>
					</div>
				)
			case "new-card":
				return (
					<WorkspaceModalError>
						<WorkspaceNewVisualForm
							metricTree={{
								bar: this.state.allKpiOptions,
								line: this.state.allKpiOptions,
								pie: this.state.allKpiOptions,
								stackedBar: this.state.allKpiOptions,
								card: this.state.allKpiOptions,
								table: this.state.allKpiOptions
							}}
							cardMetricLimits={this.state.cardMetricLimits}
							allMaps={this.state.allMaps}
							groupablesTree={this.state.groupablesTree}
							metricDefs={this.state.metricDefinitions}

							defaultFilters={this.state.defaultFilters}

							isEditMode={false}
							cardIdentity={null}

							createVisual={this.createVisual}
							saveEditVisual={this.saveEditVisual}
							closeModal={this.closeModal}
						/>
					</WorkspaceModalError>
				)
			case "edit-card":
				return (
					<WorkspaceModalError>
						<WorkspaceNewVisualForm
							metricTree={{
								bar: this.state.allKpiOptions,
								line: this.state.allKpiOptions,
								pie: this.state.allKpiOptions,
								stackedBar: this.state.allKpiOptions,
								card: this.state.allKpiOptions,
								table: this.state.allKpiOptions
							}}
							cardMetricLimits={this.state.cardMetricLimits}
							allMaps={this.state.allMaps}
							groupablesTree={this.state.groupablesTree}
							metricDefs={this.state.metricDefinitions}

							defaultFilters={this.state.defaultFilters}

							isEditMode={true}
							cardIdentity={this.state.editCardIdentity}

							createVisual={this.createVisual}
							saveEditVisual={this.saveEditVisual}
							closeModal={this.closeModal}
						/>
					</WorkspaceModalError>
				)
			case "export":
				let tmpWorkspace = null;
				let tmpCard = null;
				let cardId = null;
				this.state.workspaces.forEach(ws => {
					if (ws.id === this.state.activeWorkspaceId) {

						tmpWorkspace = ws;
						ws.publishedDetails.rows.forEach(row => {
							row.cards.forEach(card => {
								if (card != null && card.id === this.state.visualizationOpenMenuId) {
									tmpCard = card;
									cardId = card.id;
								}
							})
						})
					}
				});

				let exportName = tmpCard === null ? tmpWorkspace.publishedDetails.name : tmpCard.title;
				//onClick={() => this.exportData("pdf", tmpWorkspace, cardId)}
				return (
					<div className={"export-modal" + (tmpCard === null ? "" : " export-modal-small")}>
						<div className={"header"}>{"Export " + exportName}<div className={"workspace-model-X"} onClick={() => this.closeModal(false)}><div class="material-icons back-button">close</div></div></div>
						<div className={"export-choices-outer"}>
							{(tmpCard === null ?
							<div className={"export-choice"}>
								<div className={"fas fa-file-pdf export-icon "}></div>
								<div className={"export-info"}>{"Screen capture the Visual into an Adobe .PDF"}<br /></div>
								<div data-trackid={'export-pdf'} className={"export-button"} onClick={this.exportPdf.bind(null, tmpCard === null ? null : tmpCard)}>{"EXPORT .PDF"}</div>
								<div className={"export-note"}>Note: Export your tables to excel in order to view the complete data.</div>
								<div className={"accent-line"}></div>
							</div> : null)}
							<div className={"export-choice" + (tmpCard === null ? "" : " export-choice-small")}>
								<div className={"fas fa-file-excel export-icon"}></div>
								<div className={"export-info"}>{"Export the raw data for the Visual in an .XLSX"}</div>
								<div data-trackid={'export-excel'} className={"export-button"} onClick={() => this.exportData("excel", tmpWorkspace, cardId)}>{"EXPORT .XLSX"}</div>
								<div className={"accent-line"}></div>
							</div>
							<div className={"export-choice" + (tmpCard === null ? "" : " export-choice-small")}>
								<div className={"fas fa-file-alt export-icon"}></div>
								<div className={"export-info"}>{"Export the raw data for the Visual in a .CSV"}</div>
								<div data-trackid={'export-csv'} className={"export-button"} onClick={() => this.exportData("csv", tmpWorkspace, cardId)}>{"EXPORT .CSV"}</div>
							</div>
						</div>
					</div>
				)
			case "metricDefinitions":
				let selectedMetrics = this.retrieveSelectedMetrics();
				let finalMetricDefs = this.filterSelectedMetrics(selectedMetrics);
				return (
					<div className={"export-modal"}>
						<div className={"header"}>Metric Dictionary<div className={"workspace-model-X"} onClick={() => this.closeModal(false)}><div class="material-icons back-button">close</div></div></div>
						<div className={"metricDictionaryScroll"}>{Object.keys(finalMetricDefs).map((key, index) => (
							<div style={{ "display": "flex" }}>
								<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="book" class="svg-inline--fa fa-book fa-w-12 metricDictionarySvg" role="img" viewBox="0 0 448 512"><path fill="#29545F" d="M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z" /></svg>
								<div style={{ "width": "85%" }}>
									<div><b className={"metricDictionaryTitle"}>Name:</b> <span className={"metricDictionarySpan"}>{finalMetricDefs[key].friendlyName}</span></div>
									<div><b className={"metricDictionaryTitle"}>Description:</b> <span className={"metricDictionarySpan"}>{finalMetricDefs[key].description}</span></div>
									{finalMetricDefs[key].friendlyFormula && <div><b className={"metricDictionaryTitle"}>Formula:</b> <span className={"metricDictionarySpan"}>{finalMetricDefs[key].friendlyFormula}</span></div>}
									<hr className={"metricDictionaryHr"} />
								</div>
							</div>
						))}
						</div>
					</div>
				)
			case "share":
				let activeWorkspace = null;
				let optionsJsxCount = 0;
				let optionsContainerStyle = {};
				let userOptionLabelTxt = '';
				let userRoleOptionLabelTxt = '';

				if (this.state.activeWorkspaceId != null) {
					this.state.workspaces.forEach(ws => {
						if (ws.id === this.state.activeWorkspaceId) { activeWorkspace = ws }
					})
				}

				if (this.state.workspaceUsers.length > 0 && this.state.workspaceUsers.length < 6) {
					optionsContainerStyle.height = (optionsJsxCount * 3) + 'rem';
				} else {
					optionsContainerStyle.height = (6 * 3) + 'rem';
				}

				//set user Drop down label txt
				this.state.workspaceUsers.forEach(usr => {
					if (usr.isShared === true) {
						userOptionLabelTxt += usr.firstName + ', ';
					}
				});
				if (userOptionLabelTxt.indexOf(',') > -1 && userOptionLabelTxt.length > 2) {
					userOptionLabelTxt = userOptionLabelTxt.slice(0, -2);
				}

				//Set user role Drop down label txt
				this.state.workspaceUserRoles.forEach(role => {
					if (role.isShared === true) {
						userRoleOptionLabelTxt += role.userTypeName + ', ';
					}
				});
				if (userRoleOptionLabelTxt.indexOf(',') > -1 && userRoleOptionLabelTxt.length > 2) {
					userRoleOptionLabelTxt = userRoleOptionLabelTxt.slice(0, -2);
				}

				return (
					<div className={"share-modal"}>
						<div className={"workspace-model-X"} onClick={() => this.closeModal(false)}><div class="material-icons back-button">close</div></div>
						<div className={"share-title"}>{"Share " + activeWorkspace.title}</div>
						<div className={"share-with-roles-title"}>{"Share with the following roles: "}</div>
						<div className={"share-roles-drop-down-container" + (this.state.shareWithEntity === "roles" ? " active" : "")}>
							<div className={"share-roles-drop-down-label"} onClick={() => this.toggleShareOptions("roles")}>{userRoleOptionLabelTxt}</div>
							<div className={"material-icons roles-drop-icon"} onClick={() => this.toggleShareOptions("roles")}>{"arrow_drop_down"}</div>
							<div className={"roles-options-container"} style={{ height: this.state.shareWithEntity === "roles" ? "15rem" : "0rem" }}>
								{this.generateShareRoleOptionsJsx()}
							</div>
						</div>
						<div className={"share-with-users-title"}>{"Share with the following users: "}</div>
						<div className={"share-users-drop-down-container" + (this.state.shareWithEntity === "users" ? " active" : "")}>
							<div className={this.checkUsersList() ? "share-users-drop-down-label" : "user-drop-down-disabled-cursor share-users-drop-down-label"} onClick={() => this.checkUsersList() ? this.toggleShareOptions("users") : ""}>{userOptionLabelTxt}</div>
							<div className={this.checkUsersList() ? "material-icons users-drop-icon" : "user-drop-down-disabled-cursor material-icons users-drop-icon"} onClick={() => this.checkUsersList() ? this.toggleShareOptions("users") : ""}>{"arrow_drop_down"}</div>
							<div className={this.checkUsersList() ? "dispNone" : "share-users-not-found"}>No users found.</div>
							<div className={"users-options-container"} style={{ height: this.state.shareWithEntity === "users" ? "15rem" : "0rem" }}>
								{this.generateShareUserOptionsJsx()}
							</div>
						</div>
						{this.generateDefaultCheckBoxAreaJsx()}
						<div className={"share-button"} onClick={() => this.submitShareData()}>{"Share"}</div>
					</div>
				)

			default: return null
		}
	}

	checkUsersList() {
		let isUserPresent = false;
		this.state.workspaceUsers.forEach(user => {
			if(zzDataCache.account.userType > 0) {
				if(user.userTypeId > 0) {
					isUserPresent = true;
				}
			} else {
				isUserPresent = true;
			}
		});
		return isUserPresent;
	}

	retrieveSelectedMetrics() {
		let selectedMetrics = [];
		this.state.workspaces.forEach(workspace => {
			if(this.state.activeWorkspaceId === workspace.id) {
				workspace.publishedDetails.rows.forEach(row => {
					row.cards.forEach(card => {
						if(card !== null) {
							if(card.id === this.state.visualizationOpenMenuId) {
								card.selectedMetrics.forEach(metric => {
									selectedMetrics.push(metric.metric.toUpperCase());
								})
							}
						}
					})
				})
			}
		})
		return selectedMetrics;
	}

	filterSelectedMetrics(selectedMetrics) {
		let finalMetricDefs = {};
		if(this.state.metricDefinitions[this.state.cardType] !== undefined) {
			Object.keys(this.state.metricDefinitions[this.state.cardType]).forEach(key => {
				if(selectedMetrics.includes(key.toUpperCase())) {
					finalMetricDefs = {
						...finalMetricDefs,
						[key]: {
							...this.state.metricDefinitions[this.state.cardType][key]
						}
					}
				}
			})
		} else {
			return {...finalMetricDefs};
		}
		return {...finalMetricDefs};
	}

	render() {

		let activeWorkspace = null;
		if (this.state.activeWorkspaceId != null) {
			this.state.workspaces.forEach(ws => {
				if (ws.id === this.state.activeWorkspaceId) { activeWorkspace = ws }
			})
		}

		let openWorkspaces = this.state.workspaces.reduce((r, e) => {
			if (this.state.openWorkspaces.includes(e.id)) {
				r.push(e)
			}
			return r;
		}, [])

		if (this.state.noClientAccountId === true) {

			this.props.loadingOff();

			return (
				<div id="page-outer" className={"workspace-page-outer"}>
					<WorkspaceTopBar
						toggleNav={this.props.toggleNav}
					/>
					<div className={"workspace-page-no-client"}>
						<div className={"no-client-txt"}>{"No Client Account Selected"}<br /><br /> {"Please select an account within Profile."}</div>
					</div>
				</div>
			);
		} else {

			return (
				<div id="page-outer" className={"workspace-page-outer"}>
					<WorkspaceTopBar
						toggleNav={this.props.toggleNav}
						isAaBiDashboardOnly={this.props.isAaBiDashboardOnly}
					/>
					<WorkspaceCenter
						workspace={activeWorkspace}
						allData={this.state.allData}
						longData={this.state.longData}
						allMaps={this.state.allMaps}
						defaultKpiOrder={this.state.defaultKpiOrder}
						defaultFilters={this.state.defaultFilters}
						defaultGroupings={this.state.defaultGroupings}
						workspaceFilters={this.state.workspaceFilters}
						isDesignMode={this.state.isDesignMode}
						visualizationOpenMenuId={this.state.visualizationOpenMenuId}
						fullscreenId={this.state.fullscreenId}
						dataLoading={this.state.dataLoading}
						longDataLoading={this.state.longDataLoading}
						cardLoading={this.state.cardLoading}
						metricDefs={this.state.metricDefinitions}
						timeFilter={this.state.timeFilter}
						metricDefinitions={this.metricDefinitions}
						saveWorkspace={this.saveWorkspace}
						modifyWorkspace={this.modifyWorkspace}
						modifyWorkspaceNoSave={this.modifyWorkspaceNoSave}
						createRowId={this.createRowId}
						openModal={this.openModal}
						openNewCardModal={this.openNewCardModal}
						openEditCardModal={this.openEditCardModal}
						openFullscreen={this.openFullscreen}
						closeFullscreen={this.closeFullscreen}
						deleteVisual={this.deleteVisual}
						openVisualizationMenu={this.openVisualizationMenu}
						closeVisualizationMenu={this.closeVisualizationMenu}
						toggleChart={this.toggleChart}
						toggleLock={this.toggleLock}

						activateKeyboardShortcuts={this.activateKeyboardShortcuts}
						disableKeyboardShortcuts={this.disableKeyboardShortcuts}
					/>
					<WorkspaceLeftBar
						isOnlineStoreEnabled = {this.props.isOnlineStoreEnabled}
						isOpen={this.state.leftBarOpen}
						timeOpen={this.state.timeOpen}
						filters={this.state.filterPointer}
						timeFilter={this.state.timeFilter}
						activeFilter={this.state.activeFilter}
						expandedFilterMajors={this.state.expandedFilterMajors}
						allMaps={this.state.allMaps}

						dataLastUpdate={this.state.dataLastUpdate}
						calendarSpread={this.state.calendarSpread}
						activeWorkspaceId={this.state.activeWorkspaceId}

						selectAllFilters={this.selectAllFilters}
						deSelectAllFilters={this.deSelectAllFilters}
						setLeftBarOpen={this.setLeftBarOpen}
						setTimeOpen={this.setTimeOpen}
						setTimeRange={this.setTimeRange}
						setActiveFilter={this.setActiveFilter}
						makeFilterSelection={this.makeFilterSelection}
						makeFilterMajorSelection={this.makeFilterMajorSelection}
						expandFilterMajor={this.expandFilterMajor}
						resetFilters={this.resetFilters}
					/>
					<WorkspaceBottomBar
						allWorkspaces={this.state.workspaces}
						workspaces={openWorkspaces}
						openWorkspaceIds={this.state.openWorkspaces}
						activeWorkspaceId={this.state.activeWorkspaceId}
						isDesignMode={this.state.isDesignMode}
						isPublishing={this.state.isPublishing}
						isAaBiDashboardOnly={this.props.isAaBiDashboardOnly}

						selectWorkspace={this.selectWorkspace}
						createWorkspace={this.createWorkspace}
						duplicateWorkspace={this.duplicateWorkspace}
						deleteWorkspace={this.deleteWorkspace}
						publishWorkspace={this.publishWorkspace}
						restoreWorkspace={this.restoreWorkspace}
						closeWorkspace={this.closeWorkspace}
						closeAllWorkspaces={this.closeAllWorkspaces}
						clearAllVisuals={this.clearAllVisuals}
						toggleWorkspaceOpen={this.toggleWorkspaceOpen}
						goToDesignMode={this.goToDesignMode}
						quitDesignMode={this.quitDesignMode}
						openModal={this.openModal}
					/>
					<div className={"workspace-modal-container" + (!this.state.modalOpen ? " hidden" : "")}>
						<div className={"shadow"} onClick={this.closeModal}></div>
						<div className={"modal-card" + (this.state.modalType === "new-card" ? " fixed-top" : " fixed-top")}>
							{this.generateModalJsx()}
						</div>
					</div>
				</div>
			)

		}
	}
}